export const SAMPLE_IRIS_METRICS = [
  {
    "ID":"PI1653",
    "Metric Name":"Account Value",
    "Definition":"Disaggregates a metric representing accounts in terms of the direction of their change in value during the reporting period.\n\nSelect any that apply:\n- Increased in value during the reporting period\n- Decreased in value or stayed the same value during the reporting period\n- Other (write-in)",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP2852",
    "Metric Name":"Accounts Payable",
    "Definition":"Value, as of the end of the reporting period, of all outstanding debts that must be paid by the organization within a given period of time in order to avoid default.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP2213",
    "Metric Name":"Accounts Receivable",
    "Definition":"Value, as of the end of the reporting period, of the organization\u2019s outstanding debts from clients who received goods or services on credit.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9250",
    "Metric Name":"Active Borrowers per Loan Officer",
    "Definition":"Number of active borrowers (clients) per loan officer at the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7985",
    "Metric Name":"Active Use",
    "Definition":"Disaggregates another metric in terms of active use. For example, Client Individuals (PI4060) disaggregated by this metric, option \"active,\" would yield Active Users in many contexts. See usage guidance for further information.\n\nSelect one:\n- Active\n- Inactive\n- Data not available\n- Other (write-in)",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9101",
    "Metric Name":"Adaptation Needs Assessment ",
    "Definition":"Describes the specific adaptation needs of the region targeted by the organization. The adaptation needs can be described by a list of actions and resources required to complete all stages of adaptation process that respond to the specific climate shocks in the short and long term, starting with the specific climate vulnerability of the region and community targeted.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4180",
    "Metric Name":"After-sale Client Support",
    "Definition":"Indicates whether the organization provides support to its clients after a sale of its product\/service.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9331",
    "Metric Name":"Anti-Discrimination Policy",
    "Definition":"Indicates whether the organization has a specific, written anti-discrimination policy in place for its employees and a system to monitor compliance with this policy.\n\n\n",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5750",
    "Metric Name":"Area of Adjacent Protected Land",
    "Definition":"Area of protected land that shares a boundary with the organization's protected land as of the end of the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9170",
    "Metric Name":"Area of Buildings Reused",
    "Definition":"Area of buildings projected to be renovated or remodeled for building reuse as a result of investments made by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4765",
    "Metric Name":"Area of Community Facilities Financed",
    "Definition":"Area of community facilities projected to be constructed or preserved as a result of investments made by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7170",
    "Metric Name":"Area of Fresh Water Bodies Present",
    "Definition":"Surface area of freshwater bodies present during the reporting period on protected land, land under sustainable stewardship, or land under sustainable cultivation.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1489",
    "Metric Name":"Area of Land Deforested",
    "Definition":"Area of land deforested by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4907",
    "Metric Name":"Area of Land Reforested",
    "Definition":"Area of land that the organization reforested during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3848",
    "Metric Name":"Area of Trees Planted: Native Species",
    "Definition":"Area of land on which the organization planted native species of trees during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4127",
    "Metric Name":"Area of Trees Planted: Total",
    "Definition":"Area of land on which the organization planted trees during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"II4910",
    "Metric Name":"Assets Under Management: Managed by Fund Managers from Historically Marginalized Groups",
    "Definition":"Value of the investing organization's assets under management (AUM) invested with fund managers from groups historically marginalized due to race and\/or ethnicity as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"ID9608",
    "Metric Name":"Assets Under Management: Total",
    "Definition":"Value of the investing organization's total assets under management as of the end of the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602) selection per Hectare",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI0617",
    "Metric Name":"Availability of Basic Services\/Facilities",
    "Definition":"Indicates whether basic services are present onsite, along with a system in place to maintain them, as of the end of the reporting period. ",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5935",
    "Metric Name":"Average Agricultural Yield",
    "Definition":"Evaluates average agricultural yield per hectare of the set implied by another metric. For example, this metric applied to Client Individuals (PI4060) would yield the average agricultural yield of the organization's (farmer) clients. Organizations should calculate this metric for each individual agricultural product. See usage guidance for further information.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3468",
    "Metric Name":"Average Client Agricultural Yield: Total",
    "Definition":"Average agricultural yield per hectare of clients (who were farmers) of the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602) selection per Hectare",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9421",
    "Metric Name":"Average Client Agriculture Yield: Smallholder",
    "Definition":"Average agricultural yield per hectare of clients (who were smallholder farmers) of the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602) selection per Hectare",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI0659",
    "Metric Name":"Average Daily Traffic",
    "Definition":"Average number of vehicles per day using an urban road over the course of a year.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2248",
    "Metric Name":"Average Employee Tenure",
    "Definition":"Average tenure of employees of the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1934",
    "Metric Name":"Average Insurance Premium",
    "Definition":"Average annualized insurance premium charged for a particular insurance product provided by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5160",
    "Metric Name":"Average Loan Size Disbursed",
    "Definition":"Average loan size disbursed by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8791",
    "Metric Name":"Average Non-Salaried Wage",
    "Definition":"Average wage paid to non-salaried and full-time, part-time, or temporary employees of the organization during the reporting period. Employees who are salaried should be excluded from this calculation.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9024",
    "Metric Name":"Average Student Test Score",
    "Definition":"Average test score (as a percentage of a perfect score) earned by students served by the organization during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1405",
    "Metric Name":"Average Supplier Agricultural Yield: Smallholder",
    "Definition":"Average agricultural yield per hectare of smallholder farmers who sold to the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602) selection per Hectare",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2046",
    "Metric Name":"Average Supplier Agriculture Yield: Total",
    "Definition":"Average agricultural yield per hectare of supplier individuals who sold to the reporting organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602) selection per Hectare",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6471",
    "Metric Name":"Average Vehicle Speed",
    "Definition":"Average speed of vehicles on roads, waterways, or in flight during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"ID8539",
    "Metric Name":"Bias-Reducing Investment Practices",
    "Definition":"Describes practices the investing organization implemented during the reporting period to reduce biases in investment criteria, policies, and processes that have disproportionately negative effects on entrepreneurs who are from groups historically marginalized due to race and\/or ethnicity. See usage guidance for specific practices to address.",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5101",
    "Metric Name":"Biodegradable Materials",
    "Definition":"Amount of biodegradable materials used in the organization\u2019s products (including packaging) during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5929",
    "Metric Name":"Biodiversity Assessment",
    "Definition":"Indicates whether the organization has undertaken biodiversity-related assessments to evaluate the biological diversity and ecosystem condition present on the land that is directly or indirectly controlled by the organization.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6887",
    "Metric Name":"Biodiversity Footprint",
    "Definition":"Describes the organization\u2019s biodiversity footprint -- a measure of ecosystem intactness \u2013 on area directly or indirectly controlled by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD3292",
    "Metric Name":"Board of Directors Remuneration",
    "Definition":"Describes the compensation practices for members of the board of directors or other governing body of the reporting organization.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8118",
    "Metric Name":"Board of Directors: Female",
    "Definition":"Number of female members of the organization's board of directors or other governing body as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6696",
    "Metric Name":"Board of Directors: Historically Marginalized",
    "Definition":"Number of members of the board of directors or other governing body as of the end of the reporting period who belong to groups historically marginalized on the basis of race and\/or ethnicity.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4070",
    "Metric Name":"Board of Directors: Independent",
    "Definition":"Number of independent members of the organization's board of directors or governing body as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1075",
    "Metric Name":"Board of Directors: Total",
    "Definition":"Number of members of the organization's board of directors or other governing body as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1586",
    "Metric Name":"Building Area of Energy Efficiency Improvements",
    "Definition":"Area of buildings projected to receive energy-efficiency improvements as a result of investments made by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5490",
    "Metric Name":"Bulk Cargo Handled",
    "Definition":"Volume of bulk cargo transported through a road, railway, port, or airport during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4718",
    "Metric Name":"Business Innovation",
    "Definition":"Describes whether the organization adopted or operationalized a product, internal process, technology, or financing structure that was new or not widely used in the operating geography and sector during the reporting period.\n\nIn order to contextualize the innovation, specify whether it was previously available in the operating geography and sector, by Impact Category:\n\nFinancial Services:\n- Yes, by non-predatory informal alternatives such as family, friends, and community savings groups\n- Yes, by predatory informal alternatives such as loan sharks\n- Yes, there are a few other formal alternatives, but the market is young and not saturated\n- Yes, it is a mature market with several other formal alternatives, but the market is not saturated\n- Yes, there are several other formal alternatives and the market presents high saturation risk\n- None, our investee is the sole provider\n\nClean Energy:\n- Yes, there are several other clean, on-grid alternatives and the market presents high saturation risk\n- Yes, it is a mature market with several alternatives (both clean and dirty; on- and off-grid), but the market is not saturated\n- Yes, there are a few other clean energy alternatives, but the market is young and not saturated\n- Yes, by informal alternatives which tend to be non-renewable and off-grid\n- None, our investee is the sole provider\n\n\nOther:\n- Other (write-in)",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP2638",
    "Metric Name":"Capital Available: Borrowed Funds",
    "Definition":"Value of capital available to the organization for lending and investing as of the end of the reporting period that is attributed to debt obligations on the organization\u2019s balance sheet.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP5662",
    "Metric Name":"Capital Available: Equity Capital",
    "Definition":"Value of capital available to the organization for lending and investing at the end of the reporting period that is attributed to equity contributions.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP1307",
    "Metric Name":"Capital Available: Total",
    "Definition":"Value of capital available to the organization for lending and investing as of the end of the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP9573",
    "Metric Name":"Capital Expenditure (CapEx)",
    "Definition":"Value of funds used by a company to acquire, upgrade, and maintain physical assets such as property, plants, buildings, technology, or equipment during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4919",
    "Metric Name":"Caregivers Employed: Professionals",
    "Definition":"Number of caregiver professionals with current licenses or certifications, based on local requirements, employed by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3115",
    "Metric Name":"Caregivers Employed: Responsive",
    "Definition":"Number of caregivers who are responsive to children's needs and who are employed by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5323",
    "Metric Name":"Caregivers Employed: Total",
    "Definition":"Number of caregivers with current licenses, certifications, or trainings, based on local requirements, employed by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP6462",
    "Metric Name":"Cash and Cash Equivalents: Period End",
    "Definition":"Value of the organization's cash equivalents as of the end of the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP7264",
    "Metric Name":"Cash and Cash Equivalents: Period Start",
    "Definition":"Value of the organization's cash equivalents as of the beginning of the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP8244",
    "Metric Name":"Cash Flow: Financing Activities",
    "Definition":"Value of the organization's cash flow during the reporting period related to its financing activities.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP9703",
    "Metric Name":"Cash Flow: Investing Activities",
    "Definition":"Value of the organization's cash flow during the reporting period related to investing activities by the organization.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP3466",
    "Metric Name":"Cash Flow: Net Total",
    "Definition":"Value of the organization\u2019s net cash flow during the reporting period. Net cash flow equals inflows less outflows of cash and cash equivalents from operating, investing, financing, and other activities.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP4812",
    "Metric Name":"Cash Flow: Operating Activities",
    "Definition":"Value of the organization's cash flow during the reporting period related to operating activities.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP3774",
    "Metric Name":"Charitable Donations",
    "Definition":"Value of all financial contributions and in-kind donations of goods and services made by the organization to charities, private foundations, non-profit organizations, or non-governmental organizations during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7421",
    "Metric Name":"Charitable Practices",
    "Definition":"Indicates whether the organization employs charitable practices in its operations.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD9911",
    "Metric Name":"Child Developmental Assessment",
    "Definition":"Describes whether the organization has screened children who are using the organization's products\/services for developmental progress and delays as of the end of the reporting period.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3594",
    "Metric Name":"Child Stunting Prevalence",
    "Definition":"Ratio of children within the area served by the organization who experienced stunting as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3383",
    "Metric Name":"Claims Rejected",
    "Definition":"Number of claims submitted to the organization that were rejected during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7902",
    "Metric Name":"Claims Rejection Ratio",
    "Definition":"Percentage of claims made by clients of the organization that were rejected during the reporting period relative to the total claims submitted to the organization during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8018",
    "Metric Name":"Claims Submitted",
    "Definition":"Number of claims submitted to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5380",
    "Metric Name":"Classroom Area per Student",
    "Definition":"Area of classroom space per student during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7268",
    "Metric Name":"Classroom Space New\/Improved",
    "Definition":"Area of classroom space built, converted, or expanded for use within educational facilities during the reporting period. Report only space completed during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9435",
    "Metric Name":"Client Complaint Tracking System",
    "Definition":"Indicates whether the organization has a system in place to receive and resolve client complaints.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9872",
    "Metric Name":"Client Dropout Reasons",
    "Definition":"Describes main reasons clients drop out of a service or program (e.g., time constraints, financial constraints, disinterest).",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5049",
    "Metric Name":"Client Feedback System",
    "Definition":"Indicates whether the organization implements a feedback system to solicit client feedback and has an established procedure and\/or committee to receive and handle client feedback.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4548",
    "Metric Name":"Client Household Size",
    "Definition":"Average household size of clients of the organization during the reporting period, measured as number of individuals.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3268",
    "Metric Name":"Client Households: Historically Marginalized",
    "Definition":"Number of unique households with at least one household member who belongs to a group historically marginalized on the basis of race and\/or ethnicity and that were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7318",
    "Metric Name":"Client Households: Low Income",
    "Definition":"Number of unique low-income households that were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6991",
    "Metric Name":"Client Households: New",
    "Definition":"Number of unique households who were first-time clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2180",
    "Metric Name":"Client Households: No Direct Payment",
    "Definition":"Number of unique client households that received products\/services during the reporting period where no direct payment was provided to the organization at the time of service but for which the organization expects to be reimbursed.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7952",
    "Metric Name":"Client Households: Peri-urban",
    "Definition":"Number of unique households in peri-urban areas that were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1726",
    "Metric Name":"Client Households: Poor",
    "Definition":"Number of unique poor households that were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2845",
    "Metric Name":"Client Households: Provided New Access",
    "Definition":"Number of unique households that were clients of the organization and provided access, during the reporting period, to products\/services they were unable to access prior to the reporting period.\n\nFor further clarification, organizations should reference New Access to Water, New Access to Energy, New Access to Education, New Access to Finance, or New Access to Healthcare in the glossary.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1583",
    "Metric Name":"Client Households: Receiving Free Products\/Services",
    "Definition":"Number of unique client households who received free products\/services from the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8163",
    "Metric Name":"Client Households: Rural",
    "Definition":"Number of unique households in rural areas that were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7954",
    "Metric Name":"Client Households: Total",
    "Definition":"Number of unique households that were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1417",
    "Metric Name":"Client Households: Urban",
    "Definition":"Number of unique households in urban areas that were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6705",
    "Metric Name":"Client Households: Very Poor",
    "Definition":"Number of unique very poor households that were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8768",
    "Metric Name":"Client Housing Quality Satisfaction",
    "Definition":"NOTE: This metric has been discontinued. Please use Target Stakeholder Satisfaction Score (PI7163).",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9409",
    "Metric Name":"Client Income",
    "Definition":"Disaggregates another metric in terms of client income. For example, Client Individuals (PI4060) disaggregated by this metric would yield the number of clients with increased, decreased, or no change in income. See usage guidance for further information.\n\nReport all:\n- Large increase in income (double or more)\n- Small increase in income (less than doubled)\n- Decrease in income\n- No change in income\n- Data not available\n- Other (write-in)",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9327",
    "Metric Name":"Client Individuals: Active",
    "Definition":"Number of unique individuals who were active clients of the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1945",
    "Metric Name":"Client Individuals: Children\/Adolescents",
    "Definition":"Number of unique children and adolescents who were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8330",
    "Metric Name":"Client Individuals: Female",
    "Definition":"Number of unique women who were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5297",
    "Metric Name":"Client Individuals: Forcibly Displaced",
    "Definition":"Number of unique individuals who were forcibly displaced and were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4237",
    "Metric Name":"Client Individuals: Historically Marginalized",
    "Definition":"Number of unique individuals who belong to groups historically marginalized on the basis of race and\/or ethnicity who were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7098",
    "Metric Name":"Client Individuals: Low Income",
    "Definition":"Number of unique low-income individuals who were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8732",
    "Metric Name":"Client Individuals: New",
    "Definition":"Number of unique individuals who were first-time clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1807",
    "Metric Name":"Client Individuals: No Direct Payment",
    "Definition":"Number of unique client individuals who received products\/services during the reporting period, for which no direct payment was provided to the organization at the time of service but for which the organization expects to be reimbursed.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6266",
    "Metric Name":"Client Individuals: People with Disabilities",
    "Definition":"Number of unique individuals with disabilities who were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3960",
    "Metric Name":"Client Individuals: Peri-urban",
    "Definition":"Number of unique individuals residing in peri-urban areas who were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3193",
    "Metric Name":"Client Individuals: Poor",
    "Definition":"Number of unique poor individuals who were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2822",
    "Metric Name":"Client Individuals: Provided New Access",
    "Definition":"Number of unique client individuals who were served by the organization and provided access, during the reporting period, to products\/services they were unable to access prior to the reporting period.\n\nFor further clarification, organizations should reference New Access to Water, New Access to Energy, New Access to Education, New Access to Finance, or New Access to Healthcare in the glossary.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9622",
    "Metric Name":"Client Individuals: Receiving Free Products\/Services",
    "Definition":"Number of unique client individuals who received free products\/services from the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2185",
    "Metric Name":"Client Individuals: Referred",
    "Definition":"Number of unique individual clients of the organization who were referred by other clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6652",
    "Metric Name":"Client Individuals: Rural",
    "Definition":"Number of unique individuals residing in rural areas who were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6372",
    "Metric Name":"Client Individuals: Smallholder",
    "Definition":"Number of unique smallholder farmer individuals who were clients during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4060",
    "Metric Name":"Client Individuals: Total",
    "Definition":"Number of unique individuals who were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6751",
    "Metric Name":"Client Individuals: Urban",
    "Definition":"Number of unique individuals residing in urban areas who were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9835",
    "Metric Name":"Client Individuals: Very Poor",
    "Definition":"Number of unique very poor individuals who were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD2587",
    "Metric Name":"Client Locations",
    "Definition":"NOTE: This metric has been discontinued. Previous definition: Countries where the organization's products\/services are purchased\/used. Select from the options in the Reference List tab.",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD8350",
    "Metric Name":"Client Model",
    "Definition":"Describes the client model of the organization. Select all that apply:\n\n- Business-to-Business (B2B)\n- Business-to-Consumer (B2C)\n- Business-to-Government (B2G)\n- Peer-to-Peer (P2P)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7869",
    "Metric Name":"Client Organizations Founded: Total",
    "Definition":"Number of client organizations as of the end of the reporting period in which half or more of the lead founder(s) represent a specific group (for example, women).",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5576",
    "Metric Name":"Client Organizations Led: Total",
    "Definition":"Number of client organizations as of the end of the reporting period in which the leader (or half or more of the leaders, if there are multiple) represents a specific group (for example, women or historically marginalized groups).",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9713",
    "Metric Name":"Client Organizations: Microenterprises",
    "Definition":"Number of microenterprises that were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6894",
    "Metric Name":"Client Organizations: New",
    "Definition":"Number of enterprises that were first-time clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8952",
    "Metric Name":"Client Organizations: No Direct Payment",
    "Definition":"Number of enterprise clients that received products\/services during the reporting period for which the organization was provided no direct payment at the time of service but for which the organization expects to be reimbursed.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2575",
    "Metric Name":"Client Organizations: Provided New Access",
    "Definition":"Number of enterprise clients that were served by the organization and provided access, during the reporting period, to products\/services they were unable to access prior to the reporting period.\n\nFor further clarification, organizations should reference New Access to Water, New Access to Energy, New Access to Education, New Access to Finance, or New Access to Healthcare in the glossary.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6050",
    "Metric Name":"Client Organizations: Receiving Free Services",
    "Definition":"Number of enterprise clients that received free products\/services from the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4940",
    "Metric Name":"Client Organizations: SME",
    "Definition":"Number of small to medium-sized enterprises (SMEs) that were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9652",
    "Metric Name":"Client Organizations: Total",
    "Definition":"Number of enterprises that were clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4753",
    "Metric Name":"Client Protection Policy",
    "Definition":"Indicates whether the organization has a written policy for client protection and a system to monitor compliance with this policy.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9319",
    "Metric Name":"Client Retention Rate",
    "Definition":"Ratio of the number of the organization's active clients retained from as of the end of the reporting period compared to the number of active clients with which the organization began the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1748",
    "Metric Name":"Client Savings Premium",
    "Definition":"Percentage price savings the client obtains by purchasing a product or service from the organization and the average price that they would otherwise pay for a similar product or service in the local market.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD6806",
    "Metric Name":"Client State\/Province\/Region",
    "Definition":"States or provinces where the organization's products\/services are purchased\/used.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3291",
    "Metric Name":"Client Time Savings",
    "Definition":"Number of hours saved by clients as a result of the organization\u2019s products and services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5184",
    "Metric Name":"Client Transactions",
    "Definition":"Number of sales or client transactions during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD7993",
    "Metric Name":"Client Type",
    "Definition":"Describes the types of entities that are buyers or recipients of the organization's products\/services. Select all that apply:\n\n- Individuals\n- Households \n- Microenterprises \n- Small and Medium-Sized Enterprises \n- Large Enterprises \n- Nonprofit\/Non-Governmental Organizations\n- Governmental Organizations\n- Other",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2092",
    "Metric Name":"Climate Resilience Strategy",
    "Definition":"Indicates whether the organization implements a strategy to address the effects of climate change on the organization's operations.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2340",
    "Metric Name":"Climate Resilient Water Management Practices",
    "Definition":"Describes the type of climate resilient water management practices carried out by an organization during a reporting period.\n",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1002",
    "Metric Name":"Climate Vulnerability Status",
    "Definition":"Describes\u00a0the degree to which natural, built, or human systems are at risk of exposure to climate change impacts.\n\nChoose all that apply:\n- High\n- Medium\n- Low",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2476",
    "Metric Name":"Communities Served",
    "Definition":"Number of individuals that benefited from a product or service from within the target stakeholder group, beyond the direct client individuals of the organization.\n",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2319",
    "Metric Name":"Community Engagement Strategy",
    "Definition":"Indicates whether the organization implements a strategy to manage its interactions with local communities that are affected by its operations.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD7557",
    "Metric Name":"Community Facilities Type",
    "Definition":"Describes the type of community development facilities projected to be built, renovated, or purchased as a result of investments made by the organization during the reporting period.\n\nChoose all that apply:\n\n- Childcare\n- Education\n- Healthcare\n- Other",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9417",
    "Metric Name":"Community Health Resilience and Improvement Strategy",
    "Definition":"Indicates whether the organization implemented a community health resilience and improvement strategy during the reporting period to improve health outcomes and increase the resilience of target stakeholder populations.",
    "Reporting Format":"Unit of Measure (PD1602) selection per Hectare",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8429",
    "Metric Name":"Community Service Hours Contributed",
    "Definition":"Number of hours volunteered by full- and part-time employees of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4324",
    "Metric Name":"Community Service Policy",
    "Definition":"Indicates whether the organization implements a community service policy.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"II8439",
    "Metric Name":"Companies Considered for Investment: Led by Founders from Historically Marginalized Groups due to Race and\/or Ethnicity",
    "Definition":"Number of companies the organization considered for investment\u2014that is, in the pipeline\u2014during the reporting period that were led by founders from groups historically marginalized due to race and\/or ethnicity.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"II5202",
    "Metric Name":"Companies Considered for Investment: Total",
    "Definition":"Number of companies the organization considered for investment\u2014that is, in the pipeline\u2014during the reporting period. ",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5216",
    "Metric Name":"Complaints Ratio",
    "Definition":"Number of complaints registered per client of the reporting organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD9337",
    "Metric Name":"Compulsory Deposits",
    "Definition":"Indicates whether the organization requires clients to establish savings accounts.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD1928",
    "Metric Name":"Compulsory Insurance Products",
    "Definition":"Describes compulsory insurance products required by the organization.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2596",
    "Metric Name":"Conflict of Interest Policy",
    "Definition":"Indicates whether the organization has a written policy to monitor and disclose any potential conflicts of interest between the organization and its board members, owners, or material investors.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD1310",
    "Metric Name":"Connection Type",
    "Definition":"Describes the type of connection provided to households or individuals as a result of the organization's activities during the reporting period. \n\nChoose all that apply:\n- Piped water\n- Sewer\n- Grid electricity\n- Off-grid electricity\n- Internet\n- Phone: Mobile\n- Phone: Landline\n- Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD9009",
    "Metric Name":"Conservation Priority Characteristics",
    "Definition":"Length of protected land boundary shared with the organization's protected land as of the end of the reporting period.",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP9049",
    "Metric Name":"Cost of Goods Sold",
    "Definition":"This metric is intended to capture the organization\u2019s operating efficiency.\nValue of direct expenditures attributable to the production of goods sold by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6941",
    "Metric Name":"Cost Transparency",
    "Definition":"Indicates whether the organization fully discloses all pricing and cost information for its products and services to its clients.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5743",
    "Metric Name":"Critical Equipment\/Facility Utilization Rate",
    "Definition":"Utilization rate of an identified critical piece of equipment or facility during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3846",
    "Metric Name":"Critical Marine Habitats",
    "Definition":"Indicates whether the marine and coastal spaces directly controlled, indirectly controlled, or used (such as for transport) by the organization include important marine habitats for species.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD1620",
    "Metric Name":"Crop Type",
    "Definition":"Type(s) of crop produced by the organization during the reporting period. Select from the options in the Reference List tab.",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP6926",
    "Metric Name":"Current Assets",
    "Definition":"Value, as of the end of the reporting period, of the organization's assets that the organization reasonably expects to convert into cash within one year in the normal course of business.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP2269",
    "Metric Name":"Current Liabilities",
    "Definition":"Value, as of the end of the reporting period, of all liabilities that are expected to be settled within one year in the normal course of business.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5566",
    "Metric Name":"Damage to Infrastructure",
    "Definition":"Describes the projected loss of value of infrastructure due to climate change, disasters, or extreme weather events.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD8635",
    "Metric Name":"Days of School Offered per Year",
    "Definition":"Number of days of school offered by the organization each year.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3653",
    "Metric Name":"Departed Permanent Employees: Full-time",
    "Definition":"Number of full-time employees who departed the organization (for any reason) during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7225",
    "Metric Name":"Departed Permanent Employees: Involuntary",
    "Definition":"Number of full- and part-time employees who departed the organization involuntarily during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4499",
    "Metric Name":"Departed Permanent Employees: Total",
    "Definition":"Number of full- and part-time employees who departed the organization (for any reason) during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8431",
    "Metric Name":"Departed Permanent Employees: Voluntary",
    "Definition":"Number of full- and part-time employees who departed the organization voluntarily during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP9462",
    "Metric Name":"Depreciation and Amortization Expenses",
    "Definition":"Value of expenses recorded by the organization during the reporting period for depreciation and amortization.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI0045",
    "Metric Name":"Developmental Status",
    "Definition":"Describes the developmental status of children served by the organization as of the end of the reporting period. \n\nChoose all that apply: \n- Developmentally on track overall\n- Developmentally on track in language\n- Developmentally on track in executive function\n- Developmentally on track in health\n- Developmentally on track in social and behavioral skills\n- Developmentally delayed\n- Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1533",
    "Metric Name":"Disease\/Condition Addressed",
    "Definition":"Describes the diseases or conditions addressed by the organization's products or services provided during the reporting period. Select all that apply:\n\n- 01 Certain infectious or parasitic diseases\n- 02 Neoplasms\n- 03 Diseases of the blood or blood-forming organs\n- 04 Diseases of the immune system\n- 05 Endocrine, nutritional, or metabolic diseases\n- 06 Mental, behavioural or neurodevelopmental disorders\n- 07 Sleep-wake disorders\n- 08 Diseases of the nervous system\n- 09 Diseases of the visual system\n- 10 Diseases of the ear or mastoid process\n- 11 Diseases of the circulatory system\n- 12 Diseases of the respiratory system\n- 13 Diseases of the digestive system\n- 14 Diseases of the skin\n- 15 Diseases of the musculoskeletal system or connective tissue\n- 16 Diseases of the genitourinary system\n- 17 Conditions related to sexual health\n- 18 Pregnancy, childbirth, or the puerperium\n- 19 Certain conditions originating in the perinatal period\n- 20 Developmental anomalies\n- 21 Symptoms, signs or clinical findings, not elsewhere classified\n- 22 Injury, poisoning or certain other consequences of external causes\n- 23 External causes of morbidity or mortality\n- 24 Factors influencing health status or contact with health services\n- 25 Codes for special purposes\n- 26 Supplementary Chapter Traditional Medicine Conditions - Module I",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1160",
    "Metric Name":"Distributor Individuals: Disabilities",
    "Definition":"Number of individuals with disabilities who served as distributors of the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6659",
    "Metric Name":"Distributor Individuals: Female",
    "Definition":"Number of female individuals who served as distributors of the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8470",
    "Metric Name":"Distributor Individuals: Historically Marginalized",
    "Definition":"Number of individuals who belong to groups historically marginalized on the basis of race and\/or ethnicity and who served as distributors of the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2125",
    "Metric Name":"Distributor Individuals: Low Income",
    "Definition":"Number of low-income individuals who served as distributors of the organization's products\/services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3995",
    "Metric Name":"Distributor Individuals: Peri-urban",
    "Definition":"Number of individuals residing in peri-urban areas who served as distributors of the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9516",
    "Metric Name":"Distributor Individuals: Poor",
    "Definition":"Number of poor individuals who served as distributors of the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3972",
    "Metric Name":"Distributor Individuals: Rural",
    "Definition":"Number of individuals residing in rural areas who served as distributors of the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2758",
    "Metric Name":"Distributor Individuals: Total",
    "Definition":"Number of individuals who served as distributors of the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8982",
    "Metric Name":"Distributor Individuals: Urban",
    "Definition":"Number of individuals residing in urban areas who served as distributors of the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9113",
    "Metric Name":"Distributor Individuals: Very Poor",
    "Definition":"Number of very poor individuals who served as distributors of the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8415",
    "Metric Name":"Distributor Organizations: Microenterprises",
    "Definition":"Number of microenterprises that served as distributors of the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9401",
    "Metric Name":"Distributor Organizations: SME",
    "Definition":"Number of small and medium-sized enterprises (SMEs) that served as distributors of the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1060",
    "Metric Name":"Distributor Organizations: Total",
    "Definition":"Number of enterprises that served as distributors of the organization's products\/services during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9485",
    "Metric Name":"Diverse Representation Policy",
    "Definition":"Indicates whether the company has a written policy on diverse representation and a system to monitor compliance with this policy.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2551",
    "Metric Name":"Earnings of Distributor Individuals: Female",
    "Definition":"Earnings of female individual distributors as a result of selling the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9654",
    "Metric Name":"Earnings of Distributor Individuals: Historically Marginalized",
    "Definition":"Earnings of individuals who belong to groups historically marginalized due to race and\/or ethnicity as a result of selling the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2594",
    "Metric Name":"Earnings of Distributor Individuals: Low Income",
    "Definition":"Earnings of low-income individual distributors as a result of selling the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4341",
    "Metric Name":"Earnings of Distributor Individuals: People with Disabilities",
    "Definition":"Earnings of individual distributors with disabilities as a result of selling the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9973",
    "Metric Name":"Earnings of Distributor Individuals: Peri-urban",
    "Definition":"Value of payments made by the organization to individuals residing in peri-urban areas who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3962",
    "Metric Name":"Earnings of Distributor Individuals: Poor",
    "Definition":"Earnings of poor individual distributors as a result of selling the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8943",
    "Metric Name":"Earnings of Distributor Individuals: Rural",
    "Definition":"Earnings of individual distributors residing in rural areas as a result of selling the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4881",
    "Metric Name":"Earnings of Distributor Individuals: Total",
    "Definition":"Earnings of individual distributors as a result of selling the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9676",
    "Metric Name":"Earnings of Distributor Individuals: Urban",
    "Definition":"Earnings of individual distributors residing in urban areas as a result of selling the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5391",
    "Metric Name":"Earnings of Distributor Individuals: Very Poor",
    "Definition":"Earnings of very poor individual distributors as a result of selling the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8021",
    "Metric Name":"Earnings of Distributor Organizations: Microenterprises",
    "Definition":"Earnings of microenterprise distributors as a result of selling the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2888",
    "Metric Name":"Earnings of Distributor Organizations: SME",
    "Definition":"Earnings of distributors that are small and medium-sized enterprises (SME) as a result of selling the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6218",
    "Metric Name":"Earnings of Distributor Organizations: Total",
    "Definition":"Earnings of distributor enterprises as a result of selling the organization\u2019s products\/services during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP3673",
    "Metric Name":"EBIT",
    "Definition":"Value of the organization's net income before interest and taxes during the reporting period.\n\nEBIT signifies Earnings Before Interest and Taxes.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP1657",
    "Metric Name":"EBITDA",
    "Definition":"Value of the organization's net income before interest, taxes, depreciation, and amortization during the reporting period.\n\nEBITDA signifies Earnings Before Interest, Taxes, Depreciation, and Amortization.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9556",
    "Metric Name":"Ecological Restoration Management Area",
    "Definition":"Area of land under management for ecological restoration during the reporting period, whether directly or indirectly controlled by the organization.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD8494",
    "Metric Name":"Ecosystem Services Provided",
    "Definition":"Describes the ecosystem services\u2014that is, the societal benefits of nature\u2014provided by the ecosystem on land or marine area directly or indirectly controlled by the organization during the reporting period. Select all that apply:\n\nProvisioning Values\/Services\n\n- Food\n- Biological raw materials\n- Biomass fuel\n- Freshwater\n- Genetic resources\n- Biochemicals, natural medicines, pharmaceuticals\n\nRegulating Values\/Services\n\n- Maintenance of air quality\n- Regulation of climate\n- Regulation of water timing and flows\n- Erosion control\n- Water purification and waste treatment\n- Disease mitigation\n- Maintenance of soil quality\n- Pest mitigation\n- Pollination\n- Natural hazard mitigation\n\nSupporting Values\/Services\n\n- Habitat\n- Nutrient cycling\n- Primary production\n- Water cycling\n\nCultural Values\/Services\n\n- Recreation and ecotourism\n- Ethical and spiritual values\n- Educational and inspirational values",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4279",
    "Metric Name":"Educational Resource to Student Ratio",
    "Definition":"Number of textbooks or digital educational resources per student provided by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7467",
    "Metric Name":"Effective Interest Rate (EIR)",
    "Definition":"Value of the effective interest rate (EIR) for the organization\u2019s most representative loan product during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3601",
    "Metric Name":"Employee Feedback and Grievance System",
    "Definition":"Indicates whether the organization has in place a grievance mechanism to receive formal employee complaints and provide remedies, as well as an established procedure and\/or committee to receive and handle employee feedback.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3989",
    "Metric Name":"Employee Involuntary Turnover Rate",
    "Definition":"Ratio of the number of involuntarily departing permanent (full- and part-time) employees compared to the average number of permanent (full- and part-time) employees at the organization during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5102",
    "Metric Name":"Employee Policy Documentation",
    "Definition":"Describes the types of policy documentation that are provided to employees of the organization.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3368",
    "Metric Name":"Employee Training and Transition Programs Offered",
    "Definition":"Describes the type and scope of programs implemented and assistance provided during the reporting period to upgrade employee skills.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7390",
    "Metric Name":"Employee Training Costs",
    "Definition":"Value of the costs incurred by the organization as a result of training provided to employees (full-time, part-time, or temporary) during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7877",
    "Metric Name":"Employee Training Hours",
    "Definition":"Number of training hours provided for employees (full-time, part-time, or temporary) during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1638",
    "Metric Name":"Employee Voluntary Turnover Rate",
    "Definition":"Ratio of the number of permanent (full- and part-time) employees who departed voluntarily compared to the average number of permanent (full- and part-time) employees at the organization during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3703",
    "Metric Name":"Employees Covered by Collective Bargaining Agreements",
    "Definition":"Number of employees (including both permanent and temporary workers) who are covered by collective bargaining agreements as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6370",
    "Metric Name":"Employees Dedicated to Social and Environmental Performance",
    "Definition":"Number of full-time equivalent employees dedicated to managing social and environmental performance during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4724",
    "Metric Name":"Employees Earning a Living Wage or Higher",
    "Definition":"Number of full-time, part-time, and temporary employees of the organization who are earning a local living wage or higher as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8296",
    "Metric Name":"Employees Earning Lowest Wage",
    "Definition":"Number of full-time, part-time, and temporary employees of the organization that are earning the lowest hourly wage (including bonuses, excluding benefits) paid by the organization as of the end of the reporting period. See usage guidance for further details.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5858",
    "Metric Name":"Employees Earning Minimum Wage",
    "Definition":"Number of full-time, part-time, and temporary employees of the organization that are earning the local minimum wage as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8646",
    "Metric Name":"Employees Promoted: Female",
    "Definition":"Number of female employees who were promoted from within the organization during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6995",
    "Metric Name":"Employees Promoted: Total",
    "Definition":"Number of permanent employees who were promoted from within the organization during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI0112",
    "Metric Name":"Employees Receiving Regular Performance and Career Development Reviews",
    "Definition":"Number of permanent and temporary workers who received a routine and regular performance and career development review during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4229",
    "Metric Name":"Employees Trained",
    "Definition":"Number of employees (full-time, part-time, or temporary) who were trained through programs provided by the organization (both internally and externally) during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8358",
    "Metric Name":"Employees with Written Contracts",
    "Definition":"Number of employees (including both permanent and temporary workers) who had written contracts for their employment during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2742",
    "Metric Name":"Employment Benefits",
    "Definition":"Describes the benefits that are provided to full-time employees of the organization during the reporting period. Select all that apply:\n\n- Health insurance\n- Dental insurance \n- Unemployment insurance \n- Disability coverage\/insurance\n- Life insurance\n- Paid time off: Maternity\/birth parent leave\n- Paid time off: Paternity\/supporting parent leave\n- Paid time off: Vacation\/holiday\n- Paid time off: Sick leave\n- Flexible work arrangements\n- Childcare support (on-site, vouchers, or reimbursement)\n- Transportation support (provided by company, vouchers, or reimbursement)\n- Retirement provisions \n- Stock ownership\n- Profit-sharing\n- Other (please describe)",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8865",
    "Metric Name":"Employment Benefits Uptake",
    "Definition":"Percentage of all employees using employee benefits provided by the organization as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD3764",
    "Metric Name":"Energy Capacity",
    "Definition":"Maximum amount of energy that the organization\u2019s system can transmit (measured in kV) as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9448",
    "Metric Name":"Energy Capacity Added",
    "Definition":"Amount of new energy capacity connected to the grid during the reporting period, measured in MW.",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD2713",
    "Metric Name":"Energy Capacity of Product",
    "Definition":"Amount of energy potentially generated over the lifetime of a product based on its planned operation and context.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD1504",
    "Metric Name":"Energy Capacity of Products Sold",
    "Definition":"Amount of energy potentially generated over the lifetime of products sold by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4531",
    "Metric Name":"Energy Conservation Strategy",
    "Definition":"Indicates whether the organization implements an energy conservation strategy to reduce its operational energy usage.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6697",
    "Metric Name":"Energy Conserved",
    "Definition":"Amount of reduction in energy consumption achieved as a direct result of energy conservation and efficiency initiatives undertaken by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD6596",
    "Metric Name":"Energy Consumption of Product",
    "Definition":"Amount of energy consumed by the product during its lifetime.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD5578",
    "Metric Name":"Energy Consumption of Product Replaced",
    "Definition":"Amount of energy that would have been consumed by the replaced product during the lifetime of the organization's product.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1845",
    "Metric Name":"Energy Demand Hours Type",
    "Definition":"Describes the time frame in which the organization operated during the reporting period.\n\nChoose all that apply: \n- Peak \n- Off-Peak \n- Undisclosed \n- Other (describe) ",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1022",
    "Metric Name":"Energy Discharge Rate",
    "Definition":"Average discharge rate of the organization\u2019s storage product , measured as the energy storage capacity divided by the discharge time, during the reporting period.",
    "Reporting Format":"format",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1595",
    "Metric Name":"Energy Discharged",
    "Definition":"Amount of energy discharged (MWh or MJ) from the organization\u2019s energy storage product during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2210",
    "Metric Name":"Energy Generated for Sale: Non-Renewable",
    "Definition":"Amount of non-renewable energy generated and sold to offtaker(s) during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5842",
    "Metric Name":"Energy Generated for Sale: Renewable",
    "Definition":"Amount of renewable energy generated and sold to offtaker(s) during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8706",
    "Metric Name":"Energy Generated for Sale: Total",
    "Definition":"Amount of energy generated and sold to offtaker(s) during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1495",
    "Metric Name":"Energy Generated for Use: Non-Renewable",
    "Definition":"Amount of energy both generated and consumed by the organization from non-renewable sources during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2496",
    "Metric Name":"Energy Generated for Use: Renewable",
    "Definition":"Amount of energy both generated and consumed by the organization from renewable sources during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9624",
    "Metric Name":"Energy Generated for Use: Total",
    "Definition":"Amount of energy generated and consumed by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1496",
    "Metric Name":"Energy Purchased: Non-Renewable",
    "Definition":"Amount of purchased energy consumed by the organization from non-renewable sources during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3324",
    "Metric Name":"Energy Purchased: Renewable",
    "Definition":"Amount of purchased energy consumed by the organization from renewable sources during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8825",
    "Metric Name":"Energy Purchased: Total",
    "Definition":"Amount of purchased energy consumed by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7623",
    "Metric Name":"Energy Savings from Products Sold",
    "Definition":"Amount of energy savings over the lifetime of products sold by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD4927",
    "Metric Name":"Energy Savings from Services Sold",
    "Definition":"Amount of energy savings due to the organization's services that were sold during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI0915",
    "Metric Name":"Energy Storage Capacity",
    "Definition":"Maximum amount of energy that can be stored in the organization\u2019s energy storage product (in MWh or MJ) as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD4577",
    "Metric Name":"Energy Storage Device Cycle Life",
    "Definition":"Number of cycles that the organization\u2019s energy storage product can be charged and discharged over its lifetime as of the end of the reporting period, measured as cumulative energy (MWh or MJ).",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1435",
    "Metric Name":"Energy Stored",
    "Definition":"Amount of energy stored by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5193",
    "Metric Name":"Energy Transmitted: Total",
    "Definition":"Amount of energy transmitted by the organization during the reporting period (in MWh).",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD4108",
    "Metric Name":"Environmental Impact Objectives",
    "Definition":"Describes the environmental impact objectives pursued by the organization. Select all that apply:\n\nAgriculture\u2014Food Security:\n\n- Increasing Access to Agricultural Training and Information\n- Increasing Access to and Use of Products and Services for Agricultural Risk Mitigation\n- Increasing Access to Better, Stable Pricing of Agricultural Products\n- Increasing Farm Profitability\n- Increasing Financial Health of Farmers\n- Increasing Food Security through Smallholder Farms\n- Mitigating Climate Change through Sustainable Agriculture\n\nAgriculture\u2014Smallholder Agriculture:\n\n- Improving Agricultural Water Use Practices\n- Improving Rural Economies through Financial Inclusion\n- Increasing Access to Agricultural Training and Information\n- Increasing Access to and Use of Products and Services for Agricultural Risk Mitigation\n- Increasing Access to and Use of Quality Agricultural Inputs\n- Increasing Access to Better, Stable Pricing of Agricultural Products\n- Increasing Farm Profitability\n- Increasing Financial Health of Farmers\n- Increasing Food Security through Smallholder Farms\n- Increasing the Sustainability of Non-Wood Forest Products\n- Mitigating Climate Change through Sustainable Agriculture\n\nAgriculture\u2014Sustainable Agriculture:\n\n- Conserving River Flows for Nature and People\n- Improving Agricultural Water Use Practices\n- Mitigating Climate Change through Sustainable Agriculture\n\nAgriculture\u2014Other (describe)\n\nAir\u2014Clean Air:\n\n- Mitigating Carbon Emissions from Forestry and Land Use\n- Mitigating Climate Change through Carbon Capture and Sequestration\n- Mitigating Climate Change through Clean Electricity and Heat Production\n- Mitigating Climate Change through Clean Mobility\n- Mitigating Climate Change through Sustainable Manufacturing\n\nAir\u2014Other (describe)\n\nBiodiversity and Ecosystems\u2014Biodiversity & Ecosystem Conservation:\n\n- Conserving River Flows for Nature and People\n- Improving Agricultural Water Use Practices\n- Improving Biodiversity by Reducing Impacts from Salt- and Freshwater Aquaculture and Fisheries\n- Improving Biodiversity through Marine Ecosystem Conservation and Restoration\n- Improving Biodiversity through Nature-Based Solutions and Green Infrastructure\n- Improving Biodiversity through Terrestrial Ecosystem Protection and Restoration\n- Improving Water Quality Through Source Water Protection\n- Increasing the Sustainability of Wood and Wood-Based Products\n\nBiodiversity and Ecosystems\u2014Other (describe)\n\nClimate\u2014Climate Change Mitigation:\n\n- Improving Sustainability of Industrial and Municipal Water Practices\n- Improving WASH through Water Infrastructure and Management\n- Increasing the Sustainability of Wood and Wood-Based Products\n- Mitigating Carbon Emissions from Forestry and Land Use\n- Mitigating Climate Change through Carbon Capture and Sequestration\n-  Mitigating Climate Change through Clean Electricity and Heat Production\n- Mitigating Climate Change through Clean Mobility\n- Mitigating Climate Change through Sustainable Agriculture\n- Mitigating Climate Change through Sustainable Manufacturing\n\nClimate\u2014Climate Resilience and Adaptation:\n\n- Improving Job Skills for the Future\n- Improving WASH through Water Infrastructure and Management\n\nClimate\u2014Other (describe)\n\nDiversity and Inclusion\u2014Gender Lens:\n\n- Improving Earnings and Wealth Through Employment and Entrepreneurship (Particularly for Disadvantaged and Excluded Groups)\n- Improving Equitable Access to Education and Learning for All\n- Improving Rights, Respect, and Cooperation in the Workplace\n- Increasing Gender Equality through Financial Inclusion\n- Increasing Job Security and Stability for Workers in Precarious Employment\n- Reducing Gender Inequities in Governance, Leadership, and Ownership\n- Reducing Gender Inequities in Pay\n- Reducing Gender Inequities in Workplace Conditions\n- Reducing Gender Inequities through Tailored Products and Services\n\nDiversity and Inclusion\u2014Racial Equity:\n\n- Improving Earnings and Wealth Through Employment and Entrepreneurship (Particularly for Disadvantaged and Excluded Groups)\n- Improving Rights, Respect, and Cooperation in the Workplace\n- Increasing Inclusive Capital to Create Equitable Outcomes for Communities of Color (Justice)\n- Increasing Job Security and Stability for Workers in Precarious Employment\n- Shifting Power by Addressing Racial Bias and Ensuring Equitable Representation and Decision-Making\n- Shifting the Perception of Risk through Equitable Deal Sourcing, Due Diligence, and Terms\n\nDiversity and Inclusion\u2014Other (describe)\n\nEducation\u2014Access to Quality Education:\n\n- Improving Access to Education for Children in Crisis and Conflict-Affected Environments\n- Improving Early Childhood Care and Education\n- Improving Equitable Access to Education and Learning for All\n- Improving Job Skills for the Future\n- Improving the Quality of Teaching and Learning Environments\n- Improving The Successful Transition of Youth into the Workforce and Society\n- Improving the Transparency and Accountability of Education Management Systems\n\nEducation\u2014Other (describe)\n\nEmployment\u2014Quality Jobs:\n\n- Improving Earnings and Wealth Through Employment and Entrepreneurship (Particularly for Disadvantaged and Excluded Groups)\n- Improving Health and Well-Being Across the Workforce\n- Improving Job Skills for the Future\n- Improving Rights, Respect, and Cooperation in the Workplace\n- Increasing Job Security and Stability for Workers in Precarious Employment\n\nEmployment\u2014Other (describe)\n\nEnergy\u2014Clean Energy:\n\n- Improving Access to Clean Energy for Underserved Communities\n- Increasing Availability of Clean Energy through Improved Transmission and Distribution Infrastructure\n- Increasing Clean Energy Generation through Low- and Zero-Carbon Alternatives\n- Increasing Clean Energy Storage Capacity through Improved Batteries and Other Technologies\n- Mitigating Climate Change through Clean Electricity and Heat Production\n- Mitigating Climate Change through Clean Mobility\n\nEnergy\u2014Energy Access:\n\n- Improving Energy Alternatives for Cooking\n- Improving Energy Alternatives for Healthcare\n- Improving Energy for Connectivity\n- Improving Lighting for Business\n- Improving Lighting for Homes\n- Mitigating Climate Change through Clean Electricity and Heat Production - Reducing Harmful Emissions from Small-Scale Energy Sources\n\nEnergy\u2014Energy Efficiency:\n\n- Improving Sustainability of Industrial and Municipal Water Practices\n- Mitigating Climate Change through Clean Electricity and Heat Production\n- Mitigating Climate Change through Clean Mobility\n- Mitigating Climate Change through Sustainable Manufacturing\n\nEnergy\u2014Other (describe)\n\nFinancial Services\u2014Financial Inclusion:\n\n- Improving Access to and Use of Responsible Financial Services for Historically Underserved Populations\n- Improving Access to WASH Through Affordable Household Financing\n- Improving Earnings and Wealth Through Employment and Entrepreneurship (Particularly for Disadvantaged and Excluded Groups)\n- Improving Financial Health\n- Improving Rural Economies through Financial Inclusion\n- Increasing Access to and Use of Products and Services for Agricultural Risk Mitigation\n- Increasing Access to Non-Sewered Sanitation Services\n- Increasing Access to Sewered Sanitation Services\n- Increasing Farm Profitability\n- Increasing Financial Health of Farmers\n- Increasing Gender Equality through Financial Inclusion\n- Supporting Decent Jobs and Fostering Economic Development\n\nFinancial Services\u2014Other (describe)\n\nHealth\u2014Access to Quality Health Care:\n\n- Improving Data for Health Systems Policy and Decision-Making\n- Improving Early Childhood Care and Education\n- Improving Energy Alternatives for Healthcare\n- Improving Health and Well-Being Across the Workforce\n- Improving WASH through Water Infrastructure and Management\n- Increasing Access to Essential Medicines, Medical Supplies, and Devices\n- Increasing Access to Medical Diagnostics\n- Increasing Consistent Supply of Essential Services and Products\n- Reducing Financial Barriers to Health Services\n\nHealth\u2014Nutrition\n\nHealth\u2014Other (describe)\n\nInfrastructure\u2014Resilient Infrastructure:\n\n- Reducing Flood Risk and Stormwater Impacts through Green Infrastructure\n\nInfrastructure\u2014Other (describe)\n\nLand\u2014Natural Resources Conservation:\n\n- Improving Agricultural Water Use Practices\n- Improving Water Quality Through Source Water Protection\n\nLand\u2014Sustainable Forestry:\n\n- Increasing the Sustainability of Local Economies and Communities through Forestry and Land Use\n- Increasing the Sustainability of Non-Wood Forest Products\n- Increasing the Sustainability of Wood and Wood-Based Products\n- Mitigating Carbon Emissions from Forestry and Land Use\n\nLand\u2014Sustainable Land Management:\n\n- Improving Sustainability of Industrial and Municipal Water Practices\n\nLand\u2014Other (describe)\n\nOceans & Coastal Zones\u2014Marine Resource Conservation and Management:\n\n- Improving Water Quality Through Source Water Protection\n\nOceans & Coastal Zones\u2014Other (describe)\n\nPollution\u2014Pollution Prevention:\n\n- Improving Sustainability of Industrial and Municipal Water Practices\n- Mitigating Carbon Emissions from Forestry and Land Use\n- Reducing Harmful Emissions from Small-Scale Energy Sources\n\nPollution\u2014Other (describe)\n\nReal Estate\u2014Affordable Quality Housing:\n\n- Improving Housing Quality\n- Increasing Residential Stability\n- Increasing Housing Affordability\n- Increasing Access to Supportive Services through Housing\n\nReal Estate\u2014Green Buildings\n\nReal Estate\u2014Other (describe)\n\nWaste\u2014Waste Management:\n\n- Improving Sustainability of Industrial and Municipal Water Practices\n\nWaste\u2014Other (describe)\n\nWater\u2014Sustainable Water Management:\n\n- Conserving River Flows for Nature and People\n- Improving Access to WASH Through Affordable Household Financing\n- Improving Agricultural Water Use Practices\n- Improving Sustainability of Industrial and Municipal Water Practices\n- Improving WASH through Water Infrastructure and Management\n- Improving Water Quality Through Source Water Protection\n- Increasing Access to Non-Sewered Sanitation Services\n- Increasing Access to Sewered Sanitation Services\n- Reducing Flood Risk and Stormwater Impacts Through Green Infrastructure\n\nWater\u2014Water, Sanitation, and Hygiene (WASH):\n\n- Conserving River Flows for Nature and People\n- Improving Access to WASH in Schools and Healthcare Centers\n- Improving Access to WASH Through Affordable Household Financing\n- Improving Sustainability of Industrial and Municipal Water Practices\n- Improving WASH through Water Infrastructure and Management\n- Increasing Access to Non-Sewered Sanitation Services\n- Increasing Access to Sewered Sanitation Services\n\nWater\u2014Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1254",
    "Metric Name":"Environmental Management System",
    "Definition":"Indicates whether the organization has an environmental management system in place.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD7932",
    "Metric Name":"Environmental Policies for Financial Services Clients",
    "Definition":"Indicates whether the organization implements environmental policies associated with the organization\u2019s financing practices.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP5317",
    "Metric Name":"Equity or Net Assets",
    "Definition":"Value of the residual interest, as of the end of the reporting period, in the assets of the organization after deducting all its liabilities.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6303",
    "Metric Name":"Eviction Rate",
    "Definition":"Percentage of permanent tenants involuntarily removed from housing units during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD9759",
    "Metric Name":"Extracurricular Programs Offered",
    "Definition":"Describes the extracurricular activities that the organization offers to students.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4884",
    "Metric Name":"Fair Career Advancement Policy",
    "Definition":"Indicates whether the organization has a written policy to support the fair and equitable progression and promotion of employees and a system to monitor compliance with this policy.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3819",
    "Metric Name":"Fair Compensation Policy",
    "Definition":"Indicates whether the organization has a written policy regarding fair and equitable compensation for employees and a system to monitor compliance with this policy.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9478",
    "Metric Name":"Fair Dismissal Policy",
    "Definition":"Indicates whether the organization has a written policy and practice of ensuring fair dismissal of employees and a system to monitor compliance with this policy.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1150",
    "Metric Name":"Fair Hiring\/Recruiting Policy",
    "Definition":"Indicates whether the organization has a written employment policy to recruit employees fairly and equally and a system to monitor compliance with this policy.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP4649",
    "Metric Name":"Financial Assets",
    "Definition":"Value, as of the end of the reporting period, of the organization's non-physical assets such as cash, bank accounts, or other investments.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP2553",
    "Metric Name":"Financial Expenses",
    "Definition":"Value of expenditures incurred by the organization during the reporting period to settle interest, fees, and commissions incurred on the organization\u2019s financial liabilities\u2014including, among others, any client deposit accounts held by the organization, borrowings, and subordinated debt.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5164",
    "Metric Name":"Financial Statement Review",
    "Definition":"Indicates whether it is the organization's policy to produce financial statements that are verified annually by a certified independent auditor.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP9148",
    "Metric Name":"Fixed Assets",
    "Definition":"Value, as of the end of the reporting period, of the organization's long-term tangible assets that the organization does not expect to convert into cash in the current or upcoming fiscal year.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7983",
    "Metric Name":"Flexible Work Arrangements",
    "Definition":"Indicates whether the organization offers flexible work arrangements to full-time, part-time, or temporary employees of the organization.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9911",
    "Metric Name":"Flood Resilient Construction Practices",
    "Definition":"Describes specific flood resilience construction practices made to the housing units, buildings, infrastructure and surrounding areas. ",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2771",
    "Metric Name":"Food Insecurity Experience",
    "Definition":"Score describing the experienced severity of food security among a set of stakeholders defined by another metric or set. See usage guidance for further detail and resources.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9650",
    "Metric Name":"Forced Labor Policy",
    "Definition":"Indicates whether the organization has a written policy against forced labor and a system to monitor compliance of this policy.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4432",
    "Metric Name":"Forced Labor Policy: Child Labor",
    "Definition":"Indicates whether the organization has a written policy against child labor and a system to monitor compliance with this policy.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2622",
    "Metric Name":"Forest Management Plan",
    "Definition":"Indicates whether the organization implements a forest management plan.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI0933",
    "Metric Name":"Founder Demographics",
    "Definition":"Describes the demographic groups among founders of the organization, or disaggregates another metric in terms of one or more founder demographic groups. Particular thresholds apply to consider an organization \"founded\" by members of a demographic group; see usage guidance for further information. Select all that apply:\n\nGender:\n- 50% or More Female or Gender Non-Binary\n- Undisclosed\n- Other\n\nDisability Status:\n- Persons with disabilities\n- Persons without disabilities\n- Undisclosed\n- Other\n\nRace\/Ethnicity\/Minority Status:\n- 50% or More from Historically Marginalized Groups\n- Undisclosed\n- Other\n\nOther target populations:\n- Other (describe)",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8197",
    "Metric Name":"Founders: Female",
    "Definition":"Number of the organization\u2019s founders who are female and retain an active role in the company as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2209",
    "Metric Name":"Founders: Total",
    "Definition":"Number of the organization's founders who retain an active role in the company as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6213",
    "Metric Name":"Full-time Employees: Female",
    "Definition":"Number of paid, full-time, female employees at the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1571",
    "Metric Name":"Full-time Employees: Female Managers",
    "Definition":"Number of paid, full-time, female management employees (managers) at the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5479",
    "Metric Name":"Full-time Employees: Hired",
    "Definition":"Number of paid, full-time employees hired by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8147",
    "Metric Name":"Full-time Employees: Historically Marginalized",
    "Definition":"Number of paid, full-time employees at the organization who belong to groups historically marginalized on the basis of race and\/or ethnicity as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3140",
    "Metric Name":"Full-time Employees: Historically Marginalized Managers",
    "Definition":"Number of paid, full-time management employees (managers) at the organization who belong to groups historically marginalized on the basis of race and\/or ethnicity as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8251",
    "Metric Name":"Full-time Employees: Managers",
    "Definition":"Number of paid, full-time management employees (managers) at the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8292",
    "Metric Name":"Full-time Employees: Managers with Disabilities",
    "Definition":"Number of paid, full-time management employees (managers) with disabilities at the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2003",
    "Metric Name":"Full-time Employees: People with Disabilities",
    "Definition":"Number of paid, full-time employees at the organization with disabilities as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3160",
    "Metric Name":"Full-time Employees: Total",
    "Definition":"Number of paid full-time employees at the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8941",
    "Metric Name":"Full-time Wages: Female",
    "Definition":"Value of wages (including bonuses and excluding benefits) paid to all female full-time employees of the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5247",
    "Metric Name":"Full-time Wages: Female Management",
    "Definition":"Value of wages (including bonuses and excluding benefits) paid to all full-time female management employees (managers) of the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1508",
    "Metric Name":"Full-time Wages: Historically Marginalized",
    "Definition":"Value of wages (including bonuses and excluding benefits) paid to all full-time employees of the organization during the reporting period who belong to groups historically marginalized on the basis of race and\/or ethnicity.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3862",
    "Metric Name":"Full-time Wages: Historically Marginalized Management",
    "Definition":"Value of wages (including bonuses and excluding benefits) paid to all full-time management employees (managers) of the organization during the reporting period who belong to groups historically marginalized on the basis of race and\/or ethnicity.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6069",
    "Metric Name":"Full-time Wages: Management",
    "Definition":"Value of wages (including bonuses and excluding benefits) paid to all full-time management employees (managers) of the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5887",
    "Metric Name":"Full-time Wages: Total",
    "Definition":"Value of wages (including bonuses and excluding benefits) paid to all full-time employees of the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"II2107",
    "Metric Name":"Fund Managers: Considered for Investment",
    "Definition":"Number of unique individuals affiliated with the organization who were candidates to manage client assets via funds and\/or separate accounts during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"II5889",
    "Metric Name":"Fund Managers: Total",
    "Definition":"Number of unique individuals affiliated with the organization who were managing client assets via funds and\/or separate accounts as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9467",
    "Metric Name":"Gender Ratio of Promotions",
    "Definition":"Ratio between the number of female employees promoted from within the organization and the number of non-female employees promoted from within the organization during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1855",
    "Metric Name":"Gender Wage Equity",
    "Definition":"Ratio of the average wage paid during the reporting period to female employees of the organization for a specified position compared to the average wage paid during the reporting period to male employees of the organization for the same position.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2330",
    "Metric Name":"Governance Policies",
    "Definition":"Indicates whether the organization has written corporate governance policies that have been communicated to stakeholders.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6765",
    "Metric Name":"Green Building Practices",
    "Definition":"Indicates whether the organization employs green building practices.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD5694",
    "Metric Name":"Green Product\/Service Type",
    "Definition":"Describes how a product\/service provided by the organization contributes to a more environmentally sustainable economy, or disaggregates another metric in terms of how the related product or service contributes to a more environmentally sustainable economy.\n\nSelect all that apply:\n- Climate change mitigation\n- Climate change adaptation\n- The sustainable use and protection of water and marine resources \n- The transition to a circular economy\n- Pollution prevention and control\n- The protection and restoration of biodiversity and ecosystems\n- Product\/service does not contribute to a more environmentally sustainable economy\n- Other (write-in)",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2764",
    "Metric Name":"Greenhouse Gas Emissions Avoided",
    "Definition":"Amount of greenhouse gas (GHG) emissions avoided by the organization during the reporting period.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6774",
    "Metric Name":"Greenhouse Gas Emissions Avoided Due to Carbon Offsets Purchased",
    "Definition":"Amount of greenhouse gas (GHG) emissions avoided through carbon offsets purchased during the reporting period.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2787",
    "Metric Name":"Greenhouse Gas Emissions Avoided Due to Carbon Offsets Sold",
    "Definition":"Amount of greenhouse gas (GHG) emissions avoided through carbon credits sold during the reporting period.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5951",
    "Metric Name":"Greenhouse Gas Emissions Mitigated",
    "Definition":"Amount of greenhouse gas (GHG) emissions mitigated by the organization during the reporting period, including GHG emissions reductions from both direct and indirect sources.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9839",
    "Metric Name":"Greenhouse Gas Emissions Mitigation Types",
    "Definition":"Describes types of greenhouse gas (GHG) emissions mitigation applied by the organization during the reporting period.\n\nChoose all that apply:\n\n- GHG emission reductions from fuel combustion\n- GHG emission reductions from industrial processes (non-combustion, chemical reaction, fugitive, other)\n- GHG emission reductions from land use, land use change, and forestry\n- GHG emissions reductions from livestock\n- GHG emissions reductions from waste handling and disposal\n- GHG emissions avoided from product replacements\n- GHG emissions avoided due to carbon offsets sold\n- GHG emissions avoided due to carbon offsets purchased\n- GHG emissions sequestered from land use, land use change, and forestry\n- GHG emissions sequestered from Carbon Capture and Storage\n- Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7015",
    "Metric Name":"Greenhouse Gas Emissions of Energy Generated for Sale",
    "Definition":"Amount of greenhouse gases (GHG) emitted through production of energy by the organization that was delivered to offtaker(s) during the reporting period.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD9427",
    "Metric Name":"Greenhouse Gas Emissions of Product",
    "Definition":"Amount of greenhouse gases (GHG) emitted by a product over its lifetime. Organizations should use Product Lifetime (PD4587) to capture the lifetime of the product.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD2243",
    "Metric Name":"Greenhouse Gas Emissions of Product Replaced",
    "Definition":"Amount of greenhouse gases (GHG) that would have been emitted by the replaced product during the lifetime of the organization's product. Organizations should use Product Lifetime (PD4587) to capture the lifetime of the product.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4862",
    "Metric Name":"Greenhouse Gas Emissions Reduced",
    "Definition":"Amount of greenhouse gas (GHG) emissions reduced by the organization during the reporting period.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5732",
    "Metric Name":"Greenhouse Gas Emissions Scopes",
    "Definition":"Describes the applicable types of greenhouse gases (GHG) emitted as a result of the organization's operations during the reporting period.\n\nChoose all that apply: \n\n- Scope 1\/Direct Emissions (emissions from owned or controlled sources)\n- Scope 2\/Indirect Emissions (emissions from purchased energy)\n- Scope 3\/Indirect and direct emissions across the organization\u2019s value chain",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9878",
    "Metric Name":"Greenhouse Gas Emissions Sequestered",
    "Definition":"Amount of greenhouse gas (GHG) emissions sequestered by the organization during the reporting period.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8237",
    "Metric Name":"Greenhouse Gas Emissions Strategy",
    "Definition":"Indicates whether the organization implements a strategy to reduce greenhouse gas (GHG) emissions.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4112",
    "Metric Name":"Greenhouse Gas Emissions: Direct (Scope 1)",
    "Definition":"Amount of greenhouse gases (GHG) emitted from direct emissions sources as a result of the organization's operations during the reporting period.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9604",
    "Metric Name":"Greenhouse Gas Emissions: Indirect (Scope 2)",
    "Definition":"Amount of greenhouse gases (GHG) emitted from indirect emissions sources as a result of the organization's operations during the reporting period.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1479",
    "Metric Name":"Greenhouse Gas Emissions: Total",
    "Definition":"Amount of greenhouse gases (GHG) emitted as a result of the organization's operations during the reporting period.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5376",
    "Metric Name":"Greenhouse Gas Reductions due to Products Sold",
    "Definition":"Amount of reductions in greenhouse gas (GHG) emissions over the lifetimes of products sold during the reporting period.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6041",
    "Metric Name":"Greenhouse Gas Types",
    "Definition":"Describes the type(s) of greenhouse gases produced or mitigated by the organization during the reporting period.\n\nChoose all that apply: \n- Carbon dioxide (CO2)\n- Methane (CH4) \n- Nitrous oxide (N2O) \n- Hydrofluorocarbons (HFCs)\n- Perfluorocarbons (PFCs)\n- Sulfur hexafluoride (SF6)\n- Carbon dioxide (CO2) directly emitted from biologically sequestered carbon\n- Undisclosed",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2025",
    "Metric Name":"Gross Earned Premium",
    "Definition":"Value of premium earned by the organization as of the end of the reporting period, without any deductions for commissions or other expenses.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP2460",
    "Metric Name":"Gross Incurred Claims",
    "Definition":"Value of the organization\u2019s gross incurred claims as of the end of the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP4373",
    "Metric Name":"Gross Margin",
    "Definition":"Percentage of revenue that the organization retains after incurring the direct costs associated with the production\/delivery of its products\/services during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP7629",
    "Metric Name":"Gross Profit",
    "Definition":"Value of the organization's residual profit after incurring the direct costs associated with the production\/delivery of products\/services during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8115",
    "Metric Name":"Gross Written Premium",
    "Definition":"Amount of total insurance premium written or sold by the organization during the reporting period.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2073",
    "Metric Name":"Hazardous Waste Avoided",
    "Definition":"Amount of hazardous waste avoided through refurbishing, reusing, and recycling as part of delivering or developing the organization's products and services during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4061",
    "Metric Name":"Healthcare Benefits Participants",
    "Definition":"Number of employees who received healthcare benefits through the organization\u2019s programs during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1503",
    "Metric Name":"Healthcare Benefits Premium Covered",
    "Definition":"Percentage of a full-time employee's healthcare premium that is covered by the organization or third parties, based on benefits available to full-time employees as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3902",
    "Metric Name":"Healthcare Crude Coverage",
    "Definition":"Percentage of the organization's clients (patients) who received necessary health intervention(s) during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7191",
    "Metric Name":"Healthcare Effective Coverage",
    "Definition":"Percentage of the organization's clients (patients) who received necessary health intervention(s) during the reporting period.",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1017",
    "Metric Name":"Healthcare Facilities",
    "Definition":"Number of healthcare units\/facilities under the organization's management as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2362",
    "Metric Name":"Historically Marginalized Wage Equity",
    "Definition":"Ratio of the average wage paid for a specified position to employees of the organization who belong to groups historically marginalized on the basis of race and\/or ethnicity compared to the average wage paid to employees of the organization who do not belong to these groups but have the same position during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD4120",
    "Metric Name":"Hours of School Offered per Week",
    "Definition":"Number of classroom hours offered to a representative student each week during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD2532",
    "Metric Name":"Housing Type",
    "Definition":"Describes the type of housing units projected to be constructed or preserved as a result of investments made by the organization during the reporting period.\n\nChoose all that apply:\n\nRent or Sale: \n- Rent\n- Sale\n\nNumber of bedrooms: \n- Studio\n- 1-Bedroom\n- 2-Bedroom\n- 3-Bedroom\n- 4-Bedroom\n- 5-Bedroom\n- Other",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP1717",
    "Metric Name":"Impaired Assets",
    "Definition":"Value of assets classified as impaired under regulatory or accounting rules and recorded by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP2392",
    "Metric Name":"Impairment Loss Allowance",
    "Definition":"Value of the organization\u2019s contra asset account set up as a provision for a potential future loss of capital that has been lent out by the organization as of the end of the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5495",
    "Metric Name":"Importance of Outcome to Stakeholders",
    "Definition":"Describes the value or importance of the outcome being sought by the intervention or investment from the perspective of those affected during the reporting period.\n\nChoose all that apply:\n- Very important\n- Somewhat important\n- Neutral\n- Not important \n- Do not know",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP3297",
    "Metric Name":"Income Growth",
    "Definition":"Percentage growth in the value of the organization\u2019s net income from one reporting period to another.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP8478",
    "Metric Name":"Incurred Claims Ratio",
    "Definition":"Percentage of gross incurred claims during the reporting period relative to gross earned premiums during the same reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6482",
    "Metric Name":"Indigenous Rights and Stewardship Practices",
    "Definition":"Describes the practices used by the organization to acknowledge and support the traditional knowledge, innovations, and practices of local Indigenous communities and enable their customary use of biological resources on land, freshwater, and marine areas managed directly and indirectly by the organization. ",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3009",
    "Metric Name":"Individuals Displaced: Compensated",
    "Definition":"Number of individuals displaced as a result of projects supported\/financed by the organization who were compensated for their displacement during the reporting period. Organizations should include type and amount of compensation in footnotes.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1297",
    "Metric Name":"Individuals Displaced: Total",
    "Definition":"Number of individuals displaced as a result of projects supported\/financed by the organization during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2640",
    "Metric Name":"Individuals Housed",
    "Definition":"Number of individuals projected to be housed in single- or multi-family dwellings as a result of new construction, loans, repairs, or remodeling resulting from investments made by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5352",
    "Metric Name":"Individuals Trained: Advisory Services",
    "Definition":"Number of individuals who received one-on-one advisory services (sometimes called technical assistance) from the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7997",
    "Metric Name":"Individuals Trained: Group-Based Training",
    "Definition":"Number of individuals who received group-based training from the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2998",
    "Metric Name":"Individuals Trained: Total",
    "Definition":"Number of individuals who received training offered by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP1012",
    "Metric Name":"Interest Expenses",
    "Definition":"Value of expenditures incurred by the organization during the reporting period as a result of interest incurred on all liabilities, including any client deposit accounts held by the organization, borrowings, and subordinated debt.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD2691",
    "Metric Name":"Interest Rate Method",
    "Definition":"Describes the method(s) used by the organization to state the interest rate of its products. Select all that apply:\n\n- Declining balance method\n- Flat interest method",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8709",
    "Metric Name":"Investment Committee Members: Female",
    "Definition":"Number of female members of the organization\u2019s investment committee as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7829",
    "Metric Name":"Investment Committee Members: Total",
    "Definition":"Number of members of the organization's investment committee as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD3725",
    "Metric Name":"IRIS ID",
    "Definition":"IRIS ID of the organization reporting data.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3527",
    "Metric Name":"Job Placement Rate",
    "Definition":"Percentage of the organization\u2019s clients who were placed in part-time, full-time, temporary, or permanent jobs during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9465",
    "Metric Name":"Job Placements",
    "Definition":"Number of the organization's clients who were placed in part-time, full-time, temporary, or permanent jobs during the reporting period.",
    "Reporting Format":"Unit of reference within metric",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2251",
    "Metric Name":"Jobs Created at Directly Supported\/Financed Enterprises: Low-Income Areas",
    "Definition":"Net number of new, full-time equivalent employees living in low-income areas and working for enterprises directly financed or supported by the organization during the reporting period.\n\nMany organizations select the beginning of the reporting period as the time when the organization began its support or investment.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3687",
    "Metric Name":"Jobs Created at Directly Supported\/Financed Enterprises: Total",
    "Definition":"Net number of new, full-time equivalent employees working for enterprises financed or supported by the organization during the reporting period.\n\nMany organizations select the beginning of the reporting period as the time when the organization began its support or investment.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4874",
    "Metric Name":"Jobs in Directly Supported\/Financed Enterprises",
    "Definition":"Number of full-time equivalent employees working for enterprises financed or supported by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2688",
    "Metric Name":"Jobs Maintained at Directly Supported\/Financed Enterprises: Low-Income Areas",
    "Definition":"Number of full-time equivalent employees who reside in low-income areas and work for enterprises directly financed or supported by the organization at the beginning of the reporting period and who remain at the organization as of the end of the reporting period.\n\nMany organizations select the beginning of the reporting period as the time when the organization began its support or investment.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5691",
    "Metric Name":"Jobs Maintained at Directly Supported\/Financed Enterprises: Total",
    "Definition":"Number of full-time equivalent employees working for enterprises financed or supported by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD0660",
    "Metric Name":"Jobs Type",
    "Definition":"Describes the type of jobs supported, created, maintained, or lost during the reporting period.\n\nChoose all that apply:\n\nPermanence: \n- Permanent \n- Temporary (seasonal or repeated) \n- Temporary (one-time) \n- Other\n\nHiring: \n- Jobs hired through organization itself \n- Jobs hired\/supported through a third-party and directly related to the organization\u2019s operations and maintenance \n- Jobs hired\/supported through a third-party but not directly related to the organization\u2019s operations and maintenance \n- Other\n\nFull-Time\/Part-Time: \n- Full-time \n- Part-time\n- Other",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1674",
    "Metric Name":"Land Directly Controlled: Cultivated",
    "Definition":"Area of land directly controlled by the organization and under cultivation. Report directly controlled land area cultivated during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7560",
    "Metric Name":"Land Directly Controlled: Impervious Surfaces",
    "Definition":"Area of land directly controlled by the organization that is impervious to water during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6912",
    "Metric Name":"Land Directly Controlled: Sustainably Managed",
    "Definition":"Area of land directly controlled by the organization and under sustainable cultivation or sustainable stewardship. Report directly controlled land area sustainably managed during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5408",
    "Metric Name":"Land Directly Controlled: Total",
    "Definition":"Area of land directly controlled by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2569",
    "Metric Name":"Land Directly Controlled: Treated with Pesticides",
    "Definition":"Area of land directly controlled by the organization and treated with pesticides. Report directly controlled land area treated during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7403",
    "Metric Name":"Land Indirectly Controlled: Cultivated",
    "Definition":"Area of land indirectly controlled by the organization and under cultivation. Report indirectly controlled land area cultivated during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6796",
    "Metric Name":"Land Indirectly Controlled: Sustainably Managed",
    "Definition":"Area of land indirectly controlled by the organization and under sustainable cultivation or sustainable stewardship. Report indirectly controlled land area sustainably managed during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3789",
    "Metric Name":"Land Indirectly Controlled: Total",
    "Definition":"Area of land indirectly controlled by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI0667",
    "Metric Name":"Leadership Demographics",
    "Definition":"Describes the demographic groups in leadership of the organization, or disaggregates another metric in terms of one or more demographic groups in leadership. Particular thresholds apply to consider an organization \"led\" by members of a demographic group; see usage guidance for further information. Select all that apply:\n\nGender:\n- 30% of Greater Female or Gender Non-Binary\n- Undisclosed\n- Other\n\nDisability Status:\n- Persons with disabilities\n- Persons without disabilities\n- Undisclosed\n- Other\n\nRace\/Ethnicity\/Minority Status:\n- Historically marginalized groups\n- Dominant culture populations\n- Undisclosed\n- Other\n\nOther target populations:\n- Other (describe)",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD0754",
    "Metric Name":"Learning Environment Quality Assessment",
    "Definition":"Describes whether the organization has assessed the quality of the learning environment for children or learners who used the organization's products\/services as of the end of the reporting period.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1836",
    "Metric Name":"Learning Hours",
    "Definition":"Number of learning hours provided to students during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD9173",
    "Metric Name":"Learning Hours Provided: Type",
    "Definition":"Describes the type of learning time provided through the organization's products\/services during the reporting period.\n\nChoose all that apply (see usage guidance for definitions): \n- School time\n- Instructional time\n- Engaged time\/time-on-task\n- Supportive learning time\n- Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD2999",
    "Metric Name":"Legal Structure",
    "Definition":"Describes the legal structure of the organization. Select one:\n\n- Benefit Corporation\n- Co-op\n- Corporation\n- Limited Liability Company\n- Nonprofit\/Non-Governmental Organization\n- Partnership\n- Sole-proprietorship\n- Other",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2135",
    "Metric Name":"Length of Adjacent Protected Land",
    "Definition":"Length of protected land boundary shared with the organization's protected land as of the end of the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5840",
    "Metric Name":"Length of Coastline Present",
    "Definition":"Length of marine or freshwater coastline present during the reporting period on protected land, land under sustainable stewardship, or land under sustainable cultivation.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2538",
    "Metric Name":"Length of Coastline Restored",
    "Definition":"Length of marine or freshwater coastline under management for ecological restoration on protected land, land under sustainable stewardship, or land under sustainable cultivation during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5587",
    "Metric Name":"Length of Road Built or Improved",
    "Definition":"Length of road built or improved by the organization during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3239",
    "Metric Name":"Length of Streams Present",
    "Definition":"Length of freshwater streams present during the reporting period on protected land, land under sustainable stewardship, or land under sustainable cultivation.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6885",
    "Metric Name":"Length of Streams Restored",
    "Definition":"Length of freshwater streams under management for ecological restoration on protected land, land under sustainable stewardship, or land under sustainable cultivation during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4515",
    "Metric Name":"Length of Transmission Lines Built or Improved",
    "Definition":"Length of transmission lines built or improved by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3344",
    "Metric Name":"Level of Flood Risk",
    "Definition":"Describes the flood risk level(s) of the region(s) and communities targeted by the organization during the reporting period. \n\nChoose all that apply: \n- Low Risk\n- Low-Moderate Risk\n- Moderate Risk\n- High-Moderate Risk\n- High Risk\n- Undetermined Risk\n",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3113",
    "Metric Name":"Level of Stream Connectivity",
    "Definition":"Describes the level of fragmentation of streams\u2014the extent to which streams and rivers are fragmented into unconnected parts\u2014present on land directly or indirectly controlled by the organization as of the end of the reporting period. Report for hectares controlled at any point during the reporting period.\n\nChoose one:\n- Very low fragmentation\n- Low fragmentation\n- Moderate fragmentation\n- High fragmentation\n- Very high fragmentation\n- No data",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2799",
    "Metric Name":"Level of Water Stress",
    "Definition":"Level of baseline water stress on land directly or indirectly managed by the organization as of the end of the reporting period.\n\nChoose all that apply: \n- Low (<10%)\n- Low-medium (10\u201319.9%)\n- Medium-high (20\u201339.9%)\n- High (40\u201380%)\n- Extremely high (>80%)\n- Arid and low water use\n- No data",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD4686",
    "Metric Name":"Livestock\/Fish Type",
    "Definition":"Type of livestock product(s) produced by the organization during the reporting period. Choose all that apply from the options in the Reference List.",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5803",
    "Metric Name":"Loan Officer Wages",
    "Definition":"Value of wages (including bonuses) paid to loan officers during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2818",
    "Metric Name":"Loan Officers Employed",
    "Definition":"Number of loan officers employed by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP1192",
    "Metric Name":"Loan to Deposit (LTD) Ratio",
    "Definition":"Ratio between the organization's loans receivable gross and its total deposits as of the end of the reporting period, used to assess an organization's liquidity.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP9717",
    "Metric Name":"Loan Write-Offs",
    "Definition":"Value of loans written off by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP6750",
    "Metric Name":"Loans Payable",
    "Definition":"Value of the remaining balance, as of the end of the reporting period, on all the organization's outstanding debt obligations carried on the balance sheet.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP2630",
    "Metric Name":"Loans Receivable Gross",
    "Definition":"Value of outstanding principal for all of the organization\u2019s outstanding loans due from clients as of the end of the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP1129",
    "Metric Name":"Loans Receivable Net",
    "Definition":"Net value of the organization's loans receivable as of the end of the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP3939",
    "Metric Name":"Loans Recovered",
    "Definition":"Value of loans collected by the organization during the reporting period that had previously been written off.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9379",
    "Metric Name":"Local Compliance",
    "Definition":"Indicates whether the organization has been identified as out of compliance with any local labor, tax, or environmental regulations during the reporting period.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD6855",
    "Metric Name":"Location of Organization's Headquarters",
    "Definition":"Address of the organization's legally incorporated headquarters.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD1777",
    "Metric Name":"Location of Organization's Operating Facilities",
    "Definition":"Address of the organization's operating facilities.",
    "Reporting Format":"Text (multiple entries possible)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP6094",
    "Metric Name":"Long Term Financial Liabilities",
    "Definition":"Value, as of the end of the reporting period, of an organization's long-term financial liabilities.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7876",
    "Metric Name":"Marine Area Directly Controlled: Total",
    "Definition":"Area of marine environment directly controlled by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI0685",
    "Metric Name":"Market Linkages Improved or Expanded",
    "Definition":"Describes whether the organization improved existing market linkages or engaged new or additional forward or backward market linkages, including through its own integration, during the reporting period.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8113",
    "Metric Name":"Market Research on Clients",
    "Definition":"Indicates whether the organization uses market research to identify the needs of clients and potential clients.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4211",
    "Metric Name":"Market Share Increased",
    "Definition":"Describes whether the organization expanded operations and increased market share during the reporting period in a concentrated market in which the organization was not a dominant player.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3480",
    "Metric Name":"Median Non-Salaried Wage",
    "Definition":"Median wage paid to non-salaried and full-time, part-time, or temporary employees of the organization during the reporting period. Employees who are salaried should be excluded from this calculation.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3630",
    "Metric Name":"Meeting Frequency of Board of Directors",
    "Definition":"Number of times the organization's board of directors or governing body met during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD8501\n",
    "Metric Name":"Meter Type",
    "Definition":"Describes the type of meter provided to households or individuals with utility connections as a result of the organization's activities during the reporting period.\n\nChoose all that apply:\n\n- Operating meter\n- Non-operating\/broken meter\n- No meter\n- Undisclosed",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD7356",
    "Metric Name":"Microfinance Delivery Methodology",
    "Definition":"Describes the methodologies the organization uses to deliver financial services. Select all that apply:\n\n- Individual lending\n- Solidarity group lending\n- Village\/self-help group lending\n- Digital financial services\n- Agency banking\n- Licensed agents working on behalf of the financial service provider\n- Roving staff\/mobile branches\n- ATMs\n- Mobile banking\n- Internet-based services\n- Merchant POS or network\n- Other",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3734",
    "Metric Name":"Minimum Insurance Premium",
    "Definition":"Minimum annualized insurance premium offered for the insurance product provided by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6176",
    "Metric Name":"Minimum Wage Multiple",
    "Definition":"Ratio of the average wage of non-salaried, permanent (full- and part-time) employees of the organization during the reporting period compared to the local minimum wage as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD2735",
    "Metric Name":"Mission Statement",
    "Definition":"Describes the mission statement of the organization.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD5828",
    "Metric Name":"Name of Organization",
    "Definition":"Name of the organization.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP1301",
    "Metric Name":"Net Income",
    "Definition":"Value of the organization's net profit, calculated as total income minus total expenses, taxes, and cost of goods sold during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP3274",
    "Metric Name":"Net Income Before Donations",
    "Definition":"Value of the organization's net profit before donations, calculated as total income (excluding donations) minus total expenses during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6414",
    "Metric Name":"New Businesses Created: Low Income Areas",
    "Definition":"Number of new businesses created in low-income areas as a result of investments made by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4583",
    "Metric Name":"New Businesses Created: Total",
    "Definition":"Number of new businesses created as a result of investments made by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3141",
    "Metric Name":"New Firms Entered",
    "Definition":"Describes whether additional private sector firms entered the market in which the organization operates during the reporting period.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP8293",
    "Metric Name":"New Investment Capital",
    "Definition":"Value of funds invested in the organization (both loans and investments) during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3441",
    "Metric Name":"New Market Entered",
    "Definition":"Describes whether the organization entered a new market during the reporting period.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD9681",
    "Metric Name":"Non-financial Support Offered",
    "Definition":"Describes the type of non-financial support the organization offers to clients, if applicable.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8177",
    "Metric Name":"Non-hazardous Waste Avoided",
    "Definition":"Amount of non-hazardous waste disposal avoided through refurbishing, reusing, and recycling as part of delivering or developing the organization's products and services during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP4849",
    "Metric Name":"Non-operating Revenue",
    "Definition":"Value of revenue derived from activities not related to the organization's core operations during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP2635",
    "Metric Name":"Non-Performing Loans (Portfolio at Risk): 30 Days",
    "Definition":"Value of the organization\u2019s loans outstanding, as of the end of the reporting period, with one or more installments of principal past due for more than 30 days.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP6354",
    "Metric Name":"Non-Performing Loans (Portfolio at Risk): 60 Days",
    "Definition":"Value of the organization\u2019s loans outstanding, as of the end of the reporting period, with one or more installments of principal past due for more than 60 days.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP6373",
    "Metric Name":"Non-Performing Loans (Portfolio at Risk): 90 Days",
    "Definition":"Value of the organization\u2019s loans outstanding, as of the end of the reporting period, with one or more installments of principal past due for more than 90 days.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8007",
    "Metric Name":"Number of Community Facilities Financed",
    "Definition":"Number of community facilities projected to be built, renovated, or purchased as a result of investments made by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2197",
    "Metric Name":"Number of Complaints Registered",
    "Definition":"Number of complaints registered by clients of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7065",
    "Metric Name":"Number of Containers Handled",
    "Definition":"Number twenty-foot equivalent units (TEUs) of cargo containers transported by a road, railway, port, or airport during the reporting period.",
    "Reporting Format":"Unit of reference within metric",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1042",
    "Metric Name":"Number of Employee Grievances Registered",
    "Definition":"Number of formal grievances registered by employees of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9077",
    "Metric Name":"Number of Employee Grievances Resolved",
    "Definition":"Number of formal grievances registered by employees of the organization that were resolved during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5066",
    "Metric Name":"Number of Equity Investments Closed",
    "Definition":"Number of equity investments closed by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1914",
    "Metric Name":"Number of Equity Investments Outstanding",
    "Definition":"Number of equity investments on the organization\u2019s balance sheet as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8053",
    "Metric Name":"Number of Household and Business Connections",
    "Definition":"Number of residential and commercial connections to utilities and services provided by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2491",
    "Metric Name":"Number of Housing Units Constructed",
    "Definition":"Number of housing units constructed by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5965",
    "Metric Name":"Number of Housing Units Financed",
    "Definition":"Number of housing units projected to be constructed or preserved as a result of investments made by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6058",
    "Metric Name":"Number of Housing Units Improved",
    "Definition":"Number of housing units improved or refurbished by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3317",
    "Metric Name":"Number of Individual Connections",
    "Definition":"Number of connections to utilities and services provided to individuals by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8785",
    "Metric Name":"Number of Insurance Policies",
    "Definition":"Number of insurance policies managed by the organization as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2165",
    "Metric Name":"Number of Legal and Regulatory Complaints",
    "Definition":"Number of formal legal and regulatory complaints received by the organization during the last reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8381",
    "Metric Name":"Number of Loans Disbursed",
    "Definition":"Number of loans disbursed by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP5979",
    "Metric Name":"Number of Loans Fully Repaid on Time",
    "Definition":"Number of the organization\u2019s loans due for complete payback during the reporting period (but disbursed at any time) that were repaid no later than their due dates.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1478",
    "Metric Name":"Number of Loans Outstanding",
    "Definition":"Number of disbursed loans remaining on the organization\u2019s balance sheet as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3069",
    "Metric Name":"Number of Potential Renewals",
    "Definition":"Number of policies belonging to the organization\u2019s clients that could have been renewed during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3212",
    "Metric Name":"Number of Renewals",
    "Definition":"Number of policies belonging to the organization\u2019s clients that were renewed during the reporting period after the coverage term expired.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6504",
    "Metric Name":"Number of Routes Served",
    "Definition":"Number of directly connected port pairs or routes served during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9151",
    "Metric Name":"Number of Threatened Species",
    "Definition":"Number of threatened species present on land directly controlled by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6439",
    "Metric Name":"Number of Voluntary Savings Accounts",
    "Definition":"Number of voluntary savings accounts managed by the organization, including demand deposits and time deposits, as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6525",
    "Metric Name":"Occupational Fatalities",
    "Definition":"Indicates the number of occupational fatalities of full-time, part-time, and temporary employees of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7060",
    "Metric Name":"Occupational Illnesses",
    "Definition":"Number of occupational illnesses which affected any full-time, part-time, or temporary employees of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3757",
    "Metric Name":"Occupational Injuries",
    "Definition":"Number of occupational injuries which affected any full-time, part-time, and temporary employees of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP8569",
    "Metric Name":"Operating Efficiency",
    "Definition":"Ratio of the organization's operating expenses compared to its loans receivable as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP1001",
    "Metric Name":"Operating Expenses",
    "Definition":"Value of expenditures incurred by the organization as a result of performing its normal business operations during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP7897",
    "Metric Name":"Operating Profit Margin",
    "Definition":"Percentage of the organization's revenue that remains after paying variable costs such as wages and raw materials during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1120",
    "Metric Name":"Operational Certifications",
    "Definition":"Describes the third-party, business process- and practice-related certifications that the organization holds as of the end of the reporting period. See usage guidance for further information.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD6306",
    "Metric Name":"Operational Model",
    "Definition":"Describes the operational model of the organization. Select all that apply:\n\n- Production\/Manufacturing: Production and\/or manufacturing of goods (e.g., farming, construction, manufacturing)\n- Processing\/Packaging: Processing and\/or packaging of goods (can include both raw materials, such as wheat, and secondary materials\/goods, such as baked bread)\n- Distribution: Delivery of goods or services to target customers, whether by traditional transport (e.g., vehicle, rail, air) or infrastructure (e.g., electric grid operator)\n- Wholesale\/Retail: Intermediary organization that purchases goods and sells them to new target customers\n- Services: Services such as education, health, communications, transportation, and social services, excluding financial services\n- Financial Services: Financial products and services\n- Other (write-in)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD7796",
    "Metric Name":"Organization Web Address",
    "Definition":"Web address (URL) of the organization.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6065",
    "Metric Name":"Organizations Trained",
    "Definition":"Number of organizations that received training from the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD5098",
    "Metric Name":"Other Financial Services Offered",
    "Definition":"Describes the types of financial services the organization offers in addition to core credit, savings, and insurance products.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4221",
    "Metric Name":"Ownership Demographics",
    "Definition":"Describes the demographics of the ownership of the organization, or disaggregates another metric in terms of one or more demographic groups of ownership. Particular thresholds apply to consider an organization \"owned\" by members of a demographic group; see usage guidance for further information. Select all that apply:\n\nGender:\n- 51% or Greater Female or Gender Non-Binary\n- Undisclosed\n- Other\n\nDisability Status:\n- Persons with disabilities\n- Persons without disabilities\n- Undisclosed\n- Other\n\nRace\/Ethnicity\/Minority Status:\n- Historically marginalized groups\n- Dominant culture populations\n- Undisclosed\n\nOther target populations:\n- Other (describe)",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD2285",
    "Metric Name":"Packaging Type",
    "Definition":"Type of packaging used by the organization during the reporting period. Select all that apply:\n\n- Recycled materials\n- Non-recycled compostable or renewable materials\n- Non-recycled, non-compostable, non-renewable materials",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1422",
    "Metric Name":"Packaging Weight",
    "Definition":"Weight of packaging used by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD1392",
    "Metric Name":"Parent\/Community-Teacher Engagement",
    "Definition":"NOTE: this metric has been discontinued.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3098",
    "Metric Name":"Part-time Employee Hours Worked",
    "Definition":"Number of paid hours worked by part-time employees of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4571",
    "Metric Name":"Part-time Employees: Employees with Disabilities",
    "Definition":"Number of paid, part-time employees with disabilities at the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8838",
    "Metric Name":"Part-time Employees: Female",
    "Definition":"Number of paid, part-time, female employees at the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1903",
    "Metric Name":"Part-time Employees: Hired",
    "Definition":"Number of paid, part-time employees hired by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6508",
    "Metric Name":"Part-time Employees: Historically Marginalized",
    "Definition":"Number of paid, part-time employees at the organization who belong to groups historically marginalized on the basis of race and\/or ethnicity as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8864",
    "Metric Name":"Part-time Employees: Total",
    "Definition":"Number of paid, part-time employees at the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8725",
    "Metric Name":"Part-time Wages: Female",
    "Definition":"Value of wages (including bonuses, excluding benefits) paid to all female part-time employees of the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9956",
    "Metric Name":"Part-time Wages: Historically Marginalized",
    "Definition":"Value of wages (including bonuses and excluding benefits) paid to all part-time employees of the organization during the reporting period who belong to groups historically marginalized on the basis of race and\/or ethnicity.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9948",
    "Metric Name":"Part-time Wages: Total",
    "Definition":"Value of wages (including bonuses and excluding benefits) paid to all part-time employees of the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5060",
    "Metric Name":"Patients Completing Treatment",
    "Definition":"Number of patients who successfully completed the clinically recommended course of a health intervention during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6845",
    "Metric Name":"Patients Screened",
    "Definition":"Number of patients screened for medical conditions, illnesses, or risk factors during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP5261",
    "Metric Name":"Payments to Government",
    "Definition":"Value of all transfers to governments made by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2302",
    "Metric Name":"Payments to Supplier Individuals: Female",
    "Definition":"Value of payments made by the organization to female individuals who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7814",
    "Metric Name":"Payments to Supplier Individuals: Historically Marginalized",
    "Definition":"Value of payments made by the organization to individuals who belong to groups historically marginalized on the basis of race and\/or ethnicity and who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8999",
    "Metric Name":"Payments to Supplier Individuals: Low Income",
    "Definition":"Value of payments made by the organization to low-income individuals who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6858",
    "Metric Name":"Payments to Supplier Individuals: People with Disabilities",
    "Definition":"Value of payments made by the organization to individuals with disabilities who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9850",
    "Metric Name":"Payments to Supplier Individuals: Peri-Urban",
    "Definition":"Value of payments made by the organization to individuals residing in peri-urban areas who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7815",
    "Metric Name":"Payments to Supplier Individuals: Poor",
    "Definition":"Value of payments made by the organization to poor individuals who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4096",
    "Metric Name":"Payments to Supplier Individuals: Rural",
    "Definition":"Value of payments made by the organization to individuals residing in rural areas who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7852",
    "Metric Name":"Payments to Supplier Individuals: Smallholder",
    "Definition":"Value of payments made to smallholder farmer individuals who sold to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1492",
    "Metric Name":"Payments to Supplier Individuals: Total",
    "Definition":"Value of payments made by the organization to individuals who sold to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3406",
    "Metric Name":"Payments to Supplier Individuals: Urban",
    "Definition":"Value of payments made by the organization to individuals residing in urban areas who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9048",
    "Metric Name":"Payments to Supplier Individuals: Very Poor",
    "Definition":"Value of payments made by the organization to very poor individuals who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1849",
    "Metric Name":"Payments to Supplier Organizations: Local",
    "Definition":"Value of payments made to local enterprises that sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7867",
    "Metric Name":"Payments to Supplier Organizations: SME",
    "Definition":"Value of payments to small and medium-sized enterprises (SMEs) that sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5478",
    "Metric Name":"Payments to Supplier Organizations: Total",
    "Definition":"Value of payments made to enterprises that sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8541",
    "Metric Name":"Peak Flow Rate",
    "Definition":"Rate of maximum flow of water through a stream or river on land directly or indirectly managed by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD5833",
    "Metric Name":"Percent Affordable Housing",
    "Definition":"Percentage of the housing units projected to be constructed or preserved as a result of investments made by the organization during the reporting period that are considered affordable housing.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5776\n",
    "Metric Name":"Percent Baggage Damaged or Lost",
    "Definition":"Percentage of baggage handled by the organization that is damaged, or that has contents damaged or lost, during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5552",
    "Metric Name":"Percent Charitable Donations",
    "Definition":"Percentage of the organization's revenue that was given as charitable donations during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5660",
    "Metric Name":"Percent Employee Ownership",
    "Definition":"Percentage of the organization that is owned by individuals who are employed by the organization (full- or part-time) as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2840",
    "Metric Name":"Percent Female\/Gender Non-Binary Ownership",
    "Definition":"Percentage of the organization that is owned by female or non-binary individuals as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7194",
    "Metric Name":"Percent Ownership by Historically Marginalized Groups",
    "Definition":"Percentage of the organization that is owned, as of the end of the reporting period, by individuals who belong to groups historically marginalized due to race and\/or ethnicity.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD9364",
    "Metric Name":"Percent Recycled Materials",
    "Definition":"Percentage of recycled materials used to manufacture the organization's products (including packaging) during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8168",
    "Metric Name":"Percent Revenue Generated from Social\/Environmental Products and Services",
    "Definition":"Percentage of revenue that the organization earns from projects and services designed to deliver a specific social or environmental benefit during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4555",
    "Metric Name":"Percent Students Receiving Free and Subsidized School Meals",
    "Definition":"Percentage of students receiving free and subsidized school meals as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8632",
    "Metric Name":"Percent Supplier Payments to Stallholders",
    "Definition":"Payments made to smallholder farmer suppliers as a percentage of total payments made to all suppliers of the organization during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4559",
    "Metric Name":"Permanent Employee Wages: Female",
    "Definition":"Value of wages (including bonuses and excluding benefits) paid to all female full- and part-time employees of the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1084",
    "Metric Name":"Permanent Employee Wages: Historically Marginalized",
    "Definition":"Value of wages (including bonuses and excluding benefits) paid to all full- and part-time employees of the organization during the reporting period who belong to groups historically marginalized on the basis of race and\/or ethnicity.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7064",
    "Metric Name":"Permanent Employee Wages: Low-Income Areas",
    "Definition":"Value of wages (including bonuses and excluding benefits) paid to all full- and part-time employees of the organization who reside in low-income areas during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1682",
    "Metric Name":"Permanent Employee Wages: People with Disabilities",
    "Definition":"Value of wages (including bonuses, excluding benefits) paid to all full- and part-time employees of the organization with disabilities during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9677",
    "Metric Name":"Permanent Employee Wages: Total",
    "Definition":"Value of wages (including bonuses and excluding benefits) paid to all full- and part-time employees of the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2444",
    "Metric Name":"Permanent Employees: Female",
    "Definition":"Number of women in paid employment with the organization as of the end of the reporting period, whether they are full-time or part-time.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3547",
    "Metric Name":"Permanent Employees: Hired",
    "Definition":"Number of people hired by the organization during the reporting period, whether they are full-time or part-time.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3236",
    "Metric Name":"Permanent Employees: Historically Marginalized",
    "Definition":"Number of people in paid employment with the organization who belong to groups historically marginalized on the basis of race and\/or ethnicity as of the end of the reporting period, whether they are full-time or part-time.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8266",
    "Metric Name":"Permanent Employees: Low-Income Areas",
    "Definition":"Number of people in paid employment with the organization who reside in low-income areas as of the end of the reporting period, whether they are full-time or part-time.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4038",
    "Metric Name":"Permanent Employees: People with Disabilities",
    "Definition":"Number of people with disabilities in paid employment with the organization as of the end of the reporting period, whether they are full-time or part-time.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8869",
    "Metric Name":"Permanent Employees: Total",
    "Definition":"Number of people in paid employment with the organization as of the end of the reporting period, whether they are full-time or part-time.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP8295",
    "Metric Name":"Personnel Efficiency",
    "Definition":"Ratio of the organization's personnel expenses compared to its loans receivable as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP4831",
    "Metric Name":"Personnel Expenses",
    "Definition":"Value of expenditures related to personnel, including wages, benefits, trainings, and payroll taxes, incurred by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7394",
    "Metric Name":"Pesticide Hazard Classification Type",
    "Definition":"Describes the pesticide hazard classification for pesticides used by the organization, or disaggregates another metric in terms of pesticide hazard classification. Select all that apply:\n\n- Class Ia Extremely hazardous\n- Class Ib Highly hazardous \n- Class II Moderately hazardous \n- Class III Slightly hazardous \n- Class U Unlikely to present acute hazard\n",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9891",
    "Metric Name":"Pesticide Use",
    "Definition":"Amount of pesticides used during the reporting period on land area directly controlled by the organization.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD3569",
    "Metric Name":"Poverty Assessment",
    "Definition":"Indicates whether the organization assesses the poverty levels of its intended stakeholders.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3781",
    "Metric Name":"Primary Energy Source",
    "Definition":"Describes the primary source(s) for energy produced, sold, or purchased by the organization during the reporting period, or disaggregates another metric in terms of the primary source of the related amount of energy.\n\nSelect all that apply:\n\n- Non-renewable sources:\n\nCoal\nCrude oil derivatives\nNatural gas\nOther (write-in)\n\n- Renewable sources:\nBiomass\nGeothermal\nHydro energy\nSolar\nWind\nOther (write-in)\n\n-Other low-carbon energy sources:\nNuclear\nOther (write-in)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1568",
    "Metric Name":"Producer Price Premium",
    "Definition":"Price premium percentage that the producer (supplier) selling to the organization obtains from the organization for its goods or services during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3486",
    "Metric Name":"Product Hours of Light Available",
    "Definition":"Number of hours of light available from the product during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6209",
    "Metric Name":"Product Lifecycle Management Practices",
    "Definition":"Indicates whether the organization has practices in place to manage products over their life beyond the point of sale.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD4587",
    "Metric Name":"Product Lifetime",
    "Definition":"Number of years of useful life of the product provided by the organization (based on reasonable use).",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD5677",
    "Metric Name":"Product Targeted to Women",
    "Definition":"Indicates whether the organization offers a product or service that disproportionately benefits women.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD2756",
    "Metric Name":"Product\/Service Certifications",
    "Definition":"Describes third-party certifications for products\/services sold by the organization that are valid as of the end of the reporting period.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD7899",
    "Metric Name":"Product\/Service Description",
    "Definition":"Describes (qualitatively) the product or service provided by the organization.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD1516",
    "Metric Name":"Product\/Service Detailed Type",
    "Definition":"Describes the type of product or service provided by the organization in detail. Select from the options in the Reference List tab.",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD4861",
    "Metric Name":"Product\/Service Replaced Description",
    "Definition":"Describes the product or service replaced for clients, households, or businesses by the products or services provided by the organization.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD3017",
    "Metric Name":"Product\/Service Type",
    "Definition":"Describes the categories of economic activity that define the organization's operations.\n\nSelect all that apply:\n\nA. Agriculture, forestry, and fishing\nB. Mining and quarrying\nC. Manufacturing\nD. Electricity, gas, steam, and air conditioning supply\nE. Water supply; sewerage, waste management, and remediation activities\nF. Construction\nG. Wholesale and retail trade; repair of motor vehicles and motorcycles\nH. Transportation and storage\nI. Accommodation and food service activities\nJ. Information and communication\nK. Financial and insurance activities\nL. Real estate activities\nM. Professional, scientific, and technical activities\nN. Administrative and support service activities\nO. Public administration and defense; compulsory social security\nP. Education\nQ. Human health and social work activities\nR. Arts, entertainment, and recreation\nS. Other service activities\nT. Activities of households as employers; undifferentiated goods and services producing activities of households for own use\nU. Activities of extraterritorial organizations and bodies\nV. Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7834",
    "Metric Name":"Product\/Service Warranty",
    "Definition":"Indicates whether the organization provides a warranty for its product or service.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4128",
    "Metric Name":"Products Recalled",
    "Definition":"Number of recalls of the organization\u2019s products during the last reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8919",
    "Metric Name":"Promptness of Claims Processing",
    "Definition":"Average number of days elapsed between the submission of a completed claim by a stakeholder (client of the organization) and their receipt of payment or claim denial, for all claims settled during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9897",
    "Metric Name":"Promptness of Claims Settlement",
    "Definition":"Average number of days elapsed between the occurrence of an insured incident and the receipt of payment or claim denial by the stakeholder (client of the organization), for all claims settled (or rejected) during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2070",
    "Metric Name":"Promptness of Claims Submission",
    "Definition":"Average number of days elapsed between the occurrence of an insured incident and the submission of a complete claim by the stakeholder (client of the organization) for all claims settled during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2767",
    "Metric Name":"Protected Area Connectedness Assessment",
    "Definition":"Describes whether the organization has evaluated the continuity of natural habitats in protected areas as of the end of the reporting period.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3924",
    "Metric Name":"Protected Land Area: Permanent",
    "Definition":"Area of land with permanently protected status as of the end of the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4716",
    "Metric Name":"Protected Land Area: Total",
    "Definition":"Area of land with protected land status as of the end of the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9996",
    "Metric Name":"Provided New Access",
    "Definition":"Describes the type of prior access in a market available to an organization's clients, or disaggregates another metric in terms of type of prior access available in a market.\n\nSelect any that apply by impact theme:\n\nClean Energy\n- Previously accessed \u2018dirty\u2019 energy\n- Previously lacked any energy access\n- Previously accessed less efficient energy\n- Did not previously lack clean energy access\n- Other (write-in)\n\nOther\n- Write-in",
    "Reporting Format":"Number of Metric Tons of CO2 Equivalent",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3218",
    "Metric Name":"Public Water Point Coverage",
    "Definition":"Number of individuals within a coverage region (defined by a municipality, district, or designated service area) who have primary water access through a public tap as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9988",
    "Metric Name":"Purchase Contracts",
    "Definition":"Number of contracts and purchase agreements that the organization holds for purchase of its products\/services. Disaggregate by contracts fulfilled and contracts outstanding as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1997",
    "Metric Name":"Purchase Price of Product or Service Replaced",
    "Definition":"Indicates the average price paid in the local market by clients for a product\/service that is similar to the product\/service sold by the organization.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7643",
    "Metric Name":"Purchase Price of Product or Service Sold",
    "Definition":"Value of the purchase price paid by clients for a product or service sold by the organization.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3863",
    "Metric Name":"Quality Assurance Mechanism",
    "Definition":"Describes the quality assurance mechanisms that were in place at the organization during the reporting period. Select all that apply:\n\n- Peer review\/supervision\n- Audit and feedback\n- Checklists and logs\n- Electronic monitoring systems\n- Communication and education strategies\n- Guidelines, protocols, and registries\n- Other",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD2311",
    "Metric Name":"Racial Equity Advocacy Strategy",
    "Definition":"Indicates whether the organization has an advocacy strategy in place to support racial equity and justice efforts at local and national levels as of the end of the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"ID1046",
    "Metric Name":"Racial Equity Audit",
    "Definition":"Indicates whether the organization completed a racial equity audit during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602) selection per Hectare",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"ID0120",
    "Metric Name":"Racial Equity Negative Screen",
    "Definition":"Indicates whether the investing organization applied a racial equity\u2013focused negative screen to all investments during the reporting period, including at least an analysis of potential harmful effects on communities historically marginalized due to race and\/or ethnicity.",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"ID9449",
    "Metric Name":"Racial Equity Strategy",
    "Definition":"Indicates whether the organization implements a strategy to set targets, drive progress toward, and report on racial equity goals.",
    "Reporting Format":"Unit of Measure (PD1602) selection per Hectare",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD0482",
    "Metric Name":"Racial Equity Transparency Practice",
    "Definition":"Indicates whether the organization has a formalized and ongoing practice of sharing publicly its positions, practices, progress, and advocacy related to racial equity as a mechanism to build trust and ensure adherence.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1804",
    "Metric Name":"Records System",
    "Definition":"Describes the system used by a facility or service for record keeping, including whether it is paper-based or electronic, as of the end of the reporting period.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4328",
    "Metric Name":"Recycled Materials",
    "Definition":"Amount of recycled material used in the organization's products (including packaging) during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6286",
    "Metric Name":"Recycling Policy",
    "Definition":"Indicates whether the organization implements a recycling policy in its operating facilities.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD7900",
    "Metric Name":"Relationship to Target Stakeholders",
    "Definition":"Describes the relationship between the organization and its target stakeholders.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9206",
    "Metric Name":"Renewable Energy Expenditures",
    "Definition":"Amount of money spent by the organization for renewable energy infrastructure and technology to produce energy intended for consumption at the organization's operating facilities during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1275",
    "Metric Name":"Renewal Ratio",
    "Definition":"Percentage of the organization\u2019s clients that stay enrolled in policies after their coverage term expires during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4733",
    "Metric Name":"Repayment Capacity Analysis",
    "Definition":"Indicates whether the organization conducts repayment capacity analyses for its clients.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD7111",
    "Metric Name":"Report End Date",
    "Definition":"End date of the reporting period for which the organization is providing data.",
    "Reporting Format":"Date",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD6951",
    "Metric Name":"Report Start Date",
    "Definition":"Start date of the reporting period for which the organization is providing data.",
    "Reporting Format":"Date",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD5990",
    "Metric Name":"Reporting Currency",
    "Definition":"The national currency used to report currency figures in this IRIS report.\n\nIndicate based on the International Organization for Standardization (ISO) Currency List. Select from the options in the Reference List tab.",
    "Reporting Format":"Selection of 3 letter code",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1209",
    "Metric Name":"Responsible Financial Products\/Services Offered",
    "Definition":"Indicates whether the organization offers responsible financial products and services. See usage guidance for further information.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8255",
    "Metric Name":"Responsible Financial Products\/Services Offered",
    "Definition":"Describes the use of the financial product\/service provided by the organization, or disaggregates another metric in terms of one or more financial product or service. For loans, this is often called \"loan type.\"\n\nSelect any that apply:\n\nBasic Services\n- Mortgage\n- Home equity\n- Education\n- Green financing\n- Lease financing\n- Emergency\n- Group lending\n- Other (write-in)\n\nBusiness\n- Working capital\n- Asset financing\n- Term loans\n- Invoice financing\n- Other (write-in)\n\nOther (write-in)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP8653",
    "Metric Name":"Retained Earnings",
    "Definition":"Value of the sum of the organization's profits, cumulative from inception to the end of the reporting period, not paid out as dividends but retained by the organization for reinvestment in its core business or to pay down debt.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP4326",
    "Metric Name":"Return on Assets (ROA)",
    "Definition":"Value of an organization\u2019s net profit after taxes generated per dollar invested in total assets as of the end of the reporting period.\n\nThis is a profitability ratio calculated as net income less taxes, divided by average total assets.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP2651",
    "Metric Name":"Return on Equity (ROE)",
    "Definition":"Value of an organization\u2019s net profit generated per dollar of shareholders\u2019 equity during the reporting period.\n\nThis is a profitability ratio calculated as net income divided by average total equity or net assets.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP3021",
    "Metric Name":"Revenue from Grants and Donations",
    "Definition":"Value of revenue contributed as grants and donations during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3180",
    "Metric Name":"Revenue Generated at Directly Supported\/Financed Enterprises",
    "Definition":"Revenue of enterprises financed or supported by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP4761",
    "Metric Name":"Revenue Growth",
    "Definition":"Percentage growth in value of the organization's revenue from one reporting period to another.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1775",
    "Metric Name":"Sales Revenue",
    "Definition":"Value of revenue received during the reporting period from sales of the organization\u2019s products\/services.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7321",
    "Metric Name":"Sales Revenue: Certified",
    "Definition":"Value of revenue received from sales of the organization\u2019s certified products during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP8300",
    "Metric Name":"Sales Revenue: Collected Directly",
    "Definition":"Value of revenue during the reporting period from sales of the organization\u2019s products\/services and collected directly from clients.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP5624",
    "Metric Name":"Sales Revenue: Collected from Third Party Payers",
    "Definition":"Value of revenue during the reporting period from sales of the organization\u2019s products\/services and collected from third-party (public or private) payers.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5920",
    "Metric Name":"Sales Revenue: Exports",
    "Definition":"Value of the revenue from sales of exports of the product\/service during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD6343",
    "Metric Name":"Savings Account Incentives",
    "Definition":"Describes the types of incentives the organization offers to clients to establish savings accounts.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1081",
    "Metric Name":"School Enrollment: Female",
    "Definition":"Number of female students enrolled as of the end of the reporting period, both full- and part-time, with each discrete student counted once regardless of their number of courses.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7774",
    "Metric Name":"School Enrollment: Historically Marginalized",
    "Definition":"Number of students who belong to groups historically marginalized due to race and\/or ethnicity and who are enrolled as of the end of the reporting period, both full- and part-time, with each discrete student counted once regardless of their number of courses.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2173",
    "Metric Name":"School Enrollment: Low Income",
    "Definition":"Number of low-income students enrolled as of the end of the reporting period, both full- and part-time, with each discrete student counted once regardless of their number of courses.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5954",
    "Metric Name":"School Enrollment: People with Disabilities",
    "Definition":"Number of students with disabilities enrolled as of the end of the reporting period, both full- and part-time, with each discrete student counted once regardless of their number of courses.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3337",
    "Metric Name":"School Enrollment: Peri-urban",
    "Definition":"Number of students residing in peri-urban areas enrolled as of the end of the reporting period, both full- and part-time, with each discrete student counted once regardless of their number of courses.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7254",
    "Metric Name":"School Enrollment: Poor",
    "Definition":"Number of poor students enrolled as of the end of the reporting period, both full- and part-time, with each discrete student counted once regardless of their number of courses.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6569",
    "Metric Name":"School Enrollment: Rural",
    "Definition":"Number of students residing in rural areas enrolled as of the end of the reporting period, both full- and part-time, with each discrete student counted once regardless of their number of courses.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2389",
    "Metric Name":"School Enrollment: Total",
    "Definition":"Number of students enrolled as of the end of the reporting period, both full- and part-time, with each discrete student counted once regardless of their number of courses.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8069",
    "Metric Name":"School Enrollment: Urban",
    "Definition":"Number of students residing in urban areas enrolled as of the end of the reporting period, both full- and part-time, with each discrete student counted once regardless of their number of courses.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5583",
    "Metric Name":"School Enrollment: Very Poor",
    "Definition":"Number of very poor students enrolled as of the end of the reporting period, both full- and part-time, with each discrete student counted once regardless of their number of courses.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2718",
    "Metric Name":"School Fees",
    "Definition":"Average school fees per student per month during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6971",
    "Metric Name":"School Meals",
    "Definition":"Number of free or subsidized meals provided by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2250",
    "Metric Name":"Schooling Status",
    "Definition":"Describes the schooling status of students served by the organization during the reporting period.\n\nChoose all that apply:\n\nEnrollment status:\n- Enrolled\n- Not enrolled\n- Other (describe)\n\nGrade promotion:\n- Promoted to next year of schooling\n- Repeated year of schooling\n- Dropped out\n- Graduated \n- Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD8808",
    "Metric Name":"Sector of Operations",
    "Definition":"Describes the sector(s) in which the organization focuses its operations. Select all that apply:\nA. Agriculture, forestry, and fishing\nB. Mining and quarrying\nC. Manufacturing\nD. Electricity, gas, steam, and air conditioning supply\nE. Water supply; sewerage, waste management, and remediation activities\nF. Construction\nG. Wholesale and retail trade; repair of motor vehicles and motorcycles\nH. Transportation and storage\nI. Accommodation and food service activities\nJ. Information and communication\nK. Financial and insurance activities\nL. Real estate activities\nM. Professional, scientific, and technical activities\nN. Administrative and support service activities\nO. Public administration and defense; compulsory social security\nP. Education\nQ. Human health and social work activities\nR. Arts, entertainment, and recreation\nS. Other service activities\nT. Activities of households as employers; undifferentiated goods and services producing activities of households for own use\nU. Activities of extraterritorial organizations and bodies\nV. Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP9649",
    "Metric Name":"Selling, General, and Administration Expenses",
    "Definition":"This metric is intended to capture the costs the organization incurred during the reporting period for depreciation and amortization of assets on a defined schedule over time. ",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6686",
    "Metric Name":"Service Area Population",
    "Definition":"Number of individuals within the organization's service area (municipality, administrative region, or other geographic boundary) as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2230",
    "Metric Name":"Service Hours Interrupted",
    "Definition":"Number of hours-of-service interruptions during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5683",
    "Metric Name":"Service Hours Provided",
    "Definition":"Number of hours of service provided during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3720",
    "Metric Name":"Service Interruptions",
    "Definition":"Number of service interruptions experienced by clients during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD5205",
    "Metric Name":"Service Level Type",
    "Definition":"Describes the level of access to services provided to households or individuals as a result of the organization's activities as of the end the reporting period.\n\nChoose all that apply within the appropriate sector or service: \n\nDrinking Water\n- Safely managed\n- Basic\n- Limited\n- Unimproved\n- Surface water\n\nSanitation\n- Safely managed\n- Basic\n- Limited\n- Unimproved\n- Open defecation\n\nHygiene\n- Basic\n- Limited\n- No facility\n\nElectricity\n- Tier 5 (advanced access)\n- Tier 4\n- Tier 3\n- Tier 2\n- Tier 1\n- Tier 0 (no access)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD1007",
    "Metric Name":"Setting of Housing\/Community Facilities",
    "Definition":"Describes the setting of community development facilities or housing units projected to be constructed or preserved as a result of investments made by the organization during the reporting period.\n\nChoose all that apply:\n\n- Urban\n- Rural\n- Peri-urban\n- Other",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9088",
    "Metric Name":"Sexual Harassment Policy",
    "Definition":"Indicates whether the organization has a written policy to combat and prevent the sexual harassment of employees and a system to monitor compliance with this policy.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1984",
    "Metric Name":"Social and Environmental Board Committee",
    "Definition":"Indicates whether the organization has a formal board of directors or governing body committee dedicated to social and environmental performance.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4953",
    "Metric Name":"Social and Environmental Performance Incentives",
    "Definition":"Indicates whether the organization implemented any employee incentive schemes related to social and\/or environmental performance goals during the reporting period.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4136",
    "Metric Name":"Social and Environmental Performance Management Training",
    "Definition":"Indicates whether any member of the organization's board of directors participated in training sessions related to any aspect of managing environmental or social performance during the reporting period.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4732",
    "Metric Name":"Social and Environmental Performance Reporting",
    "Definition":"Indicates whether the organization reports its social and environmental performance to relevant stakeholders.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9106",
    "Metric Name":"Social and Environmental Performance Risk Assessment",
    "Definition":"Indicates whether the organization assessed social and environmental risks during the reporting period.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3943",
    "Metric Name":"Social and Environmental Performance Staff Training",
    "Definition":"Indicates whether any of the organization's employees participated in training sessions related to any aspect of managing environmental or social performance during the reporting period.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD4091",
    "Metric Name":"Social and Environmental Targets",
    "Definition":"Describes the quantifiable social and environmental targets set by the organization.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD6247",
    "Metric Name":"Social Impact Objectives",
    "Definition":"Describes the social impact objectives pursued by the organization. Select all that apply:\n\nAgriculture\u2014Food Security:\n\n- Increasing Access to Agricultural Training and Information\n- Increasing Access to and Use of Products and Services for Agricultural Risk Mitigation\n- Increasing Access to Better, Stable Pricing of Agricultural Products\n- Increasing Farm Profitability\n- Increasing Financial Health of Farmers\n- Increasing Food Security through Smallholder Farms\n- Mitigating Climate Change through Sustainable Agriculture\n\nAgriculture\u2014Smallholder Agriculture:\n\n- Improving Agricultural Water Use Practices\n- Improving Rural Economies through Financial Inclusion\n- Increasing Access to Agricultural Training and Information\n- Increasing Access to and Use of Products and Services for Agricultural Risk Mitigation\n- Increasing Access to and Use of Quality Agricultural Inputs\n- Increasing Access to Better, Stable Pricing of Agricultural Products\n- Increasing Farm Profitability\n- Increasing Financial Health of Farmers\n- Increasing Food Security through Smallholder Farms\n- Increasing the Sustainability of Non-Wood Forest Products\n- Mitigating Climate Change through Sustainable Agriculture\n\nAgriculture\u2014Sustainable Agriculture:\n\n- Conserving River Flows for Nature and People\n- Improving Agricultural Water Use Practices\n- Mitigating Climate Change through Sustainable Agriculture\n\nAgriculture\u2014Other (describe)\n\nAir\u2014Clean Air:\n\n- Mitigating Carbon Emissions from Forestry and Land Use\n- Mitigating Climate Change through Carbon Capture and Sequestration\n- Mitigating Climate Change through Clean Electricity and Heat Production\n- Mitigating Climate Change through Clean Mobility\n- Mitigating Climate Change through Sustainable Manufacturing\n\nAir\u2014Other (describe)\n\nBiodiversity and Ecosystems\u2014Biodiversity & Ecosystem Conservation:\n\n- Conserving River Flows for Nature and People\n- Improving Agricultural Water Use Practices\n- Improving Biodiversity by Reducing Impacts from Salt- and Freshwater Aquaculture and Fisheries\n- Improving Biodiversity through Marine Ecosystem Conservation and Restoration\n- Improving Biodiversity through Nature-Based Solutions and Green Infrastructure\n- Improving Biodiversity through Terrestrial Ecosystem Protection and Restoration\n- Improving Water Quality Through Source Water Protection\n- Increasing the Sustainability of Wood and Wood-Based Products\n\nBiodiversity and Ecosystems\u2014Other (describe)\n\nClimate\u2014Climate Change Mitigation:\n\n- Improving Sustainability of Industrial and Municipal Water Practices\n- Improving WASH through Water Infrastructure and Management\n- Increasing the Sustainability of Wood and Wood-Based Products\n- Mitigating Carbon Emissions from Forestry and Land Use\n- Mitigating Climate Change through Carbon Capture and Sequestration\n-  Mitigating Climate Change through Clean Electricity and Heat Production\n- Mitigating Climate Change through Clean Mobility\n- Mitigating Climate Change through Sustainable Agriculture\n- Mitigating Climate Change through Sustainable Manufacturing\n\nClimate\u2014Climate Resilience and Adaptation:\n\n- Improving Job Skills for the Future\n- Improving WASH through Water Infrastructure and Management\n\nClimate\u2014Other (describe)\n\nDiversity and Inclusion\u2014Gender Lens:\n\n- Improving Earnings and Wealth Through Employment and Entrepreneurship (Particularly for Disadvantaged and Excluded Groups)\n- Improving Equitable Access to Education and Learning for All\n- Improving Rights, Respect, and Cooperation in the Workplace\n- Increasing Gender Equality through Financial Inclusion\n- Increasing Job Security and Stability for Workers in Precarious Employment\n- Reducing Gender Inequities in Governance, Leadership, and Ownership\n- Reducing Gender Inequities in Pay\n- Reducing Gender Inequities in Workplace Conditions\n- Reducing Gender Inequities through Tailored Products and Services\n\nDiversity and Inclusion\u2014Racial Equity:\n\n- Improving Earnings and Wealth Through Employment and Entrepreneurship (Particularly for Disadvantaged and Excluded Groups)\n- Improving Rights, Respect, and Cooperation in the Workplace\n- Increasing Inclusive Capital to Create Equitable Outcomes for Communities of Color (Justice)\n- Increasing Job Security and Stability for Workers in Precarious Employment\n- Shifting Power by Addressing Racial Bias and Ensuring Equitable Representation and Decision-Making\n- Shifting the Perception of Risk through Equitable Deal Sourcing, Due Diligence, and Terms\n\nDiversity and Inclusion\u2014Other (describe)\n\nEducation\u2014Access to Quality Education:\n\n- Improving Access to Education for Children in Crisis and Conflict-Affected Environments\n- Improving Early Childhood Care and Education\n- Improving Equitable Access to Education and Learning for All\n- Improving Job Skills for the Future\n- Improving the Quality of Teaching and Learning Environments\n- Improving The Successful Transition of Youth into the Workforce and Society\n- Improving the Transparency and Accountability of Education Management Systems\n\nEducation\u2014Other (describe)\n\nEmployment\u2014Quality Jobs:\n\n- Improving Earnings and Wealth Through Employment and Entrepreneurship (Particularly for Disadvantaged and Excluded Groups)\n- Improving Health and Well-Being Across the Workforce\n- Improving Job Skills for the Future\n- Improving Rights, Respect, and Cooperation in the Workplace\n- Increasing Job Security and Stability for Workers in Precarious Employment\n\nEmployment\u2014Other (describe)\n\nEnergy\u2014Clean Energy:\n\n- Improving Access to Clean Energy for Underserved Communities\n- Increasing Availability of Clean Energy through Improved Transmission and Distribution Infrastructure\n- Increasing Clean Energy Generation through Low- and Zero-Carbon Alternatives\n- Increasing Clean Energy Storage Capacity through Improved Batteries and Other Technologies\n- Mitigating Climate Change through Clean Electricity and Heat Production\n- Mitigating Climate Change through Clean Mobility\n\nEnergy\u2014Energy Access:\n\n- Improving Energy Alternatives for Cooking\n- Improving Energy Alternatives for Healthcare\n- Improving Energy for Connectivity\n- Improving Lighting for Business\n- Improving Lighting for Homes\n- Mitigating Climate Change through Clean Electricity and Heat Production - Reducing Harmful Emissions from Small-Scale Energy Sources\n\nEnergy\u2014Energy Efficiency:\n\n- Improving Sustainability of Industrial and Municipal Water Practices\n- Mitigating Climate Change through Clean Electricity and Heat Production\n- Mitigating Climate Change through Clean Mobility\n- Mitigating Climate Change through Sustainable Manufacturing\n\nEnergy\u2014Other (describe)\n\nFinancial Services\u2014Financial Inclusion:\n\n- Improving Access to and Use of Responsible Financial Services for Historically Underserved Populations\n- Improving Access to WASH Through Affordable Household Financing\n- Improving Earnings and Wealth Through Employment and Entrepreneurship (Particularly for Disadvantaged and Excluded Groups)\n- Improving Financial Health\n- Improving Rural Economies through Financial Inclusion\n- Increasing Access to and Use of Products and Services for Agricultural Risk Mitigation\n- Increasing Access to Non-Sewered Sanitation Services\n- Increasing Access to Sewered Sanitation Services\n- Increasing Farm Profitability\n- Increasing Financial Health of Farmers\n- Increasing Gender Equality through Financial Inclusion\n- Supporting Decent Jobs and Fostering Economic Development\n\nFinancial Services\u2014Other (describe)\n\nHealth\u2014Access to Quality Health Care:\n\n- Improving Data for Health Systems Policy and Decision-Making\n- Improving Early Childhood Care and Education\n- Improving Energy Alternatives for Healthcare\n- Improving Health and Well-Being Across the Workforce\n- Improving WASH through Water Infrastructure and Management\n- Increasing Access to Essential Medicines, Medical Supplies, and Devices\n- Increasing Access to Medical Diagnostics\n- Increasing Consistent Supply of Essential Services and Products\n- Reducing Financial Barriers to Health Services\n\nHealth\u2014Nutrition\n\nHealth\u2014Other (describe)\n\nInfrastructure\u2014Resilient Infrastructure:\n\n- Reducing Flood Risk and Stormwater Impacts through Green Infrastructure\n\nInfrastructure\u2014Other (describe)\n\nLand\u2014Natural Resources Conservation:\n\n- Improving Agricultural Water Use Practices\n- Improving Water Quality Through Source Water Protection\n\nLand\u2014Sustainable Forestry:\n\n- Increasing the Sustainability of Local Economies and Communities through Forestry and Land Use\n- Increasing the Sustainability of Non-Wood Forest Products\n- Increasing the Sustainability of Wood and Wood-Based Products\n- Mitigating Carbon Emissions from Forestry and Land Use\n\nLand\u2014Sustainable Land Management:\n\n- Improving Sustainability of Industrial and Municipal Water Practices\n\nLand\u2014Other (describe)\n\nOceans & Coastal Zones\u2014Marine Resource Conservation and Management:\n\n- Improving Water Quality Through Source Water Protection\n\nOceans & Coastal Zones\u2014Other (describe)\n\nPollution\u2014Pollution Prevention:\n\n- Improving Sustainability of Industrial and Municipal Water Practices\n- Mitigating Carbon Emissions from Forestry and Land Use\n- Reducing Harmful Emissions from Small-Scale Energy Sources\n\nPollution\u2014Other (describe)\n\nReal Estate\u2014Affordable Quality Housing:\n\n- Improving Housing Quality\n- Increasing Residential Stability\n- Increasing Housing Affordability\n- Increasing Access to Supportive Services through Housing\n\nReal Estate\u2014Green Buildings\n\nReal Estate\u2014Other (describe)\n\nWaste\u2014Waste Management:\n\n- Improving Sustainability of Industrial and Municipal Water Practices\n\nWaste\u2014Other (describe)\n\nWater\u2014Sustainable Water Management:\n\n- Conserving River Flows for Nature and People\n- Improving Access to WASH Through Affordable Household Financing\n- Improving Agricultural Water Use Practices\n- Improving Sustainability of Industrial and Municipal Water Practices\n- Improving WASH through Water Infrastructure and Management\n- Improving Water Quality Through Source Water Protection\n- Increasing Access to Non-Sewered Sanitation Services\n- Increasing Access to Sewered Sanitation Services\n- Reducing Flood Risk and Stormwater Impacts Through Green Infrastructure\n\nWater\u2014Water, Sanitation, and Hygiene (WASH):\n\n- Conserving River Flows for Nature and People\n- Improving Access to WASH in Schools and Healthcare Centers\n- Improving Access to WASH Through Affordable Household Financing\n- Improving Sustainability of Industrial and Municipal Water Practices\n- Improving WASH through Water Infrastructure and Management\n- Increasing Access to Non-Sewered Sanitation Services\n- Increasing Access to Sewered Sanitation Services\n\nWater\u2014Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7783",
    "Metric Name":"Social Responsibility Client Policies",
    "Definition":"Indicates whether the organization implements policies to protect its clients.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6381",
    "Metric Name":"Soil Conservation Practices",
    "Definition":"Indicates which soil conservation practices the organization implemented during the reporting period.\n\nSelect all that apply:\n\n- Application of regionally appropriate practices to minimize disturbance of and physical damage to soil, cropland, and pasturelands\n- Prevention of soil erosion, acidification, salinization, and accumulation of adverse compounds not otherwise specified\n- Other (describe)",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1047",
    "Metric Name":"Soil Health Practices",
    "Definition":"Indicates which sustainable agriculture best practices the organization implemented to maintain and enhance soil health of agricultural lands during the reporting period.\n\nSelect all that apply:\n\n- Application of regionally appropriate soil health improvement practices to maintain or enhance soil fertility and the physical and biological characteristics of soil\n- Monitoring of those soil health characteristics, including nutrients from different sources, that are necessary to maintain or enhance appropriate nutrient balance and soil health\n- Development and maintenance of an up-to-date nutrient management program that efficiently uses nutrient inputs and nutrients in the soil and crops to create optimum conditions for production and avoids nutrient loss to water and air\n- Other (describe)\n- Undisclosed",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP6152",
    "Metric Name":"Solvency Ratio",
    "Definition":"Ratio of an organization\u2019s admitted assets to liabilities, per their statutory accounts, as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8394",
    "Metric Name":"Space Per Passenger",
    "Definition":"Amount of space per passenger (in an airport, passenger port, or vehicle) during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8027",
    "Metric Name":"Species Abundance",
    "Definition":"Indicates the number of individuals of a particular species that are present on area directly or indirectly controlled by the organization as of the end of the reporting period. ",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD2584",
    "Metric Name":"Species Area of Habitat",
    "Definition":"Describes the area of habitat available to a species within that species' range during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD6429",
    "Metric Name":"Species Conservation Status",
    "Definition":"Describes the conservation status of species during the reporting period. \n\n\nChoose all that apply: \n\n- Least concern\n- Near threatened\n- Vulnerable\n- Endangered\n- Critically endangered\n- Extinct in the wild\n- Extinct\n- Data deficient\n- Not evaluated",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD6363",
    "Metric Name":"Species Extinction Threat",
    "Definition":"Describes applicable threats to species during the reporting period. \n\nChoose all that apply: \n\nResidential & commercial development\n- Housing & urban areas\n- Commercial & industrial areas\n- Tourism & recreation areas\n\nAgriculture & aquaculture \n- Annual & perennial non-timber crops: Shifting agriculture\n- Annual & perennial non-timber crops: Smallholder farming\n- Annual & perennial non-timber crops: Agro-industry farming\n- Annual & perennial non-timber crops: Scale unknown\/unrecorded\n- Wood & pulp plantations: \nSmall-holder plantations\n- Wood & pulp plantations: Agro-industry plantations\n- Wood & pulp plantations: Scale unknown\/unrecorded\n- Livestock farming & ranching: Nomadic grazing\n- Livestock farming & ranching: Small-holder grazing, ranching or farming\n- Livestock farming & ranching: Agro-industry grazing, ranching or farming\n- Livestock farming & ranching: Scale unknown\/unrecorded\n- Marine & freshwater aquaculture: Subsistence\/artisanal aquaculture\n- Marine & freshwater aquaculture:  Industrial aquaculture\n- Marine & freshwater aquaculture: Scale unknown\/unrecorded\n\nEnergy production & mining\n- Oil & gas drilling\n- Mining & quarrying\n- Renewable energy\n- Other energy production & mining (describe)\n\nTransportation & service corridors\n- Roads & railroads\n- Utility & service lines\n- Shipping lanes\n- Flight paths\n\nBiological resource use\n- Hunting & collecting terrestrial animals:  Intentional use (species being assessed is the target)\n- Hunting & collecting terrestrial animals: Unintentional effects (species being assessed is not the target)\n- Hunting & collecting terrestrial animals: Persecution\/control\n- Hunting & collecting terrestrial animals: Motivation unknown\/unrecorded\n- Gathering terrestrial plants:  Intentional use (species being assessed is the target)\n- Gathering terrestrial plants: Unintentional effects (species being assessed is not the target)\n- Gathering terrestrial plants: Persecution\/control\n- Gathering terrestrial plants: Motivation unknown\/unrecorded\n- Logging & wood harvesting:  Intentional use, subsistence\/small scale (species being assessed is the target)\n- Logging & wood harvesting:  Intentional use, large scale (species being assessed is the target)\n- Logging & wood harvesting:  Unintentional effects, subsistence\/small scale (species being assessed is not the target)\n- Logging & wood harvesting:  Unintentional effects, large scale (species being assessed is not the target)\n- Logging & wood harvesting: Motivation unknown\/unrecorded\n- Fishing & harvesting aquatic resources:  Intentional use, subsistence\/small scale (species being assessed is the target)\n- Fishing & harvesting aquatic resources:  Intentional use, large scale (species being assessed is the target)\n- Fishing & harvesting aquatic resources:  Unintentional effects, subsistence\/small scale (species being assessed is not the target)\n- Fishing & harvesting aquatic resources:  Unintentional effects, large scale (species being assessed is not the target)\n- Fishing & harvesting aquatic resources: Persecution\/control\n- Fishing & harvesting aquatic resources: Motivation unknown\/unrecorded\n\nHuman intrusions & disturbance\n- Recreational activities\n- War, civil unrest, & military exercises\n- Work & other activities\n- Other human intrusions & disturbances (describe)\n\nNatural system modifications\n- Fire & fire suppression: Increase in fire frequency\/intensity\n- Fire & fire suppression: Suppression in fire frequency\/intensity\n- Fire & fire suppression: Trend unknown\/unrecorded\n- Dams & water management\/use: Abstraction of surface water (domestic use)\n- Dams & water management\/use: Abstraction of surface water (commercial use)\n- Dams & water management\/use: Abstraction of surface water (agricultural use)\n- Dams & water management\/use: Abstraction of surface water (unknown use)\n- Dams & water management\/use: Abstraction of groundwater (domestic use)\n- Dams & water management\/use: Abstraction of groundwater (commercial use)\n- Dams & water management\/use: Abstraction of groundwater (agricultural use)\n- Dams & water management\/use: Abstraction of groundwater (unknown use)\n- Dams & water management\/use: Small dams\n- Dams & water management\/use: Large dams\n- Dams & water management\/use: Dams (size unknown)\n- Other ecosystem modifications (describe)\n\nInvasive & other problematic species, genes, & diseases\n- Invasive non-native\/alien species\/diseases: Unspecified species\n- Invasive non-native\/alien species\/diseases: Named species\n- Problematic native species\/diseases: Unspecified species\n- Problematic native species\/diseases: Named species\n- Introduced genetic material\n- Problematic species\/diseases of unknown origin: Unspecified species\n- Problematic species\/diseases of unknown origin: Named species\n- Viral\/prion-induced diseases: Unspecified \u201cspecies\u201d (disease)\n- Viral\/prion-induced diseases: Named \u201cspecies\u201d (disease)\n- Diseases of unknown cause \n\nPollution\n- Domestic & urban wastewater: Sewage\n- Domestic & urban wastewater: Run-off\n- Domestic & urban wastewater: Type unknown\/unrecorded\n- Industrial & military effluents: Oil spills\n- Industrial & military effluents: Seepage from mining\n- Industrial & military effluents: Type unknown\/unrecorded\n- Agricultural & forestry effluents: Nutrient loads\n- Agricultural & forestry effluents: Soil erosion, sedimentation\n- Agricultural & forestry effluents: Herbicides & pesticides\n- Agricultural & forestry effluents: Type unknown\/unrecorded\n- Garbage & solid waste\n- Air-borne pollutants: Acid rain\n- Air-borne pollutants: Smog\n- Air-borne pollutants: Ozone\n- Air-borne pollutants: Type unknown\/unrecorded\n- Excess energy: Light pollution\n- Excess energy: Thermal pollution\n- Excess energy: Noise pollution\n- Excess energy: Type unknown\/unrecorded\n\nGeological events\n- Volcanoes\n- Earthquakes\/tsunamis\n- Avalanches\/landslides\n- Other geological events (describe)\n\nClimate change & severe weather\n- Habitat shifting & alteration\n- Droughts\n- Temperature extremes\n- Storms & flooding\n- Other impacts (describe)\n\nOther options\n- Other threat (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7728",
    "Metric Name":"Species: Total",
    "Definition":"Indicates the number of different species (species richness) present within the area managed directly or indirectly by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7914",
    "Metric Name":"Stakeholder Engagement",
    "Definition":"Describes the mechanisms in place to gather input from stakeholders on product\/service design, development, and delivery. Select all that apply: \n\n- Identify community need(s), if any, in collaboration with target stakeholders\n- Consult with target stakeholders about their needs when developing strategy\n- Collect impact data from stakeholders via interviews and\/or surveys\n- Work with investees to reflect target stakeholders' perspectives in product\/service offerings\n- Monitor target stakeholder satisfaction\n- None\n- Other (describe)",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD6737",
    "Metric Name":"Stormwater Runoff",
    "Definition":"Volume of water generated from rain and snowmelt flowing over (that is, without soaking into the ground) land indirectly or directly controlled by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3798",
    "Metric Name":"Stream Nutrient Levels Assessment",
    "Definition":"Indicates whether the organization has assessed nitrogen and phosphorus levels in streams on directly or indirectly controlled land as of the end of the reporting period.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3979",
    "Metric Name":"Stream Turbidity Level",
    "Definition":"Level of turbidity (in Nephelometric Turbidity Units, or NTU) observed in streams or rivers on land directly or indirectly managed by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9202",
    "Metric Name":"Streamflow Rate",
    "Definition":"Rate of flowing water in a stream or river on land directly or indirectly managed by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8670",
    "Metric Name":"Strikes and Lockouts",
    "Definition":"Number of employees' strikes and lockouts at the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3786",
    "Metric Name":"Student Attendance Rate",
    "Definition":"Rate of student attendance during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9910",
    "Metric Name":"Student Dropout Rate",
    "Definition":"Percentage of students who were attending school at the beginning of the reporting period but who dropped out during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4924",
    "Metric Name":"Student Promotion Rate",
    "Definition":"Percentage of students advancing from one grade of schooling to the next during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8372",
    "Metric Name":"Student Tests Pass Rate",
    "Definition":"Percentage of students at a school passing standardized tests offered by a regional governance body during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5501",
    "Metric Name":"Student to Classroom Ratio",
    "Definition":"Number of students per classroom during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5110",
    "Metric Name":"Student to Teacher Ratio",
    "Definition":"Number of students per teacher during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4243",
    "Metric Name":"Student to Toilet Ratio",
    "Definition":"Number of students per functioning toilet during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1136",
    "Metric Name":"Student Transportation",
    "Definition":"Indicates if the organization provided transportation to students that needed or requested it during the reporting period.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4509",
    "Metric Name":"Students Provided Full Scholarship",
    "Definition":"Number of students receiving full scholarship during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3499",
    "Metric Name":"Students Provided Partial Scholarship",
    "Definition":"Number of students receiving partial scholarships during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1728",
    "Metric Name":"Supplier Individuals: Female",
    "Definition":"Number of female individuals who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9261",
    "Metric Name":"Supplier Individuals: Historically Marginalized",
    "Definition":"Number of individuals who belong to groups historically marginalized on the basis of race and\/or ethnicity and who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8819",
    "Metric Name":"Supplier Individuals: Low Income",
    "Definition":"Number of low-income individuals who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6189",
    "Metric Name":"Supplier Individuals: People with Disabilities",
    "Definition":"Number of individuals with disabilities who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6085",
    "Metric Name":"Supplier Individuals: Peri-urban",
    "Definition":"Number of individuals residing in peri-urban areas who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2242",
    "Metric Name":"Supplier Individuals: Poor",
    "Definition":"Number of poor individuals who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2566",
    "Metric Name":"Supplier Individuals: Rural",
    "Definition":"Number of individuals residing in rural areas who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9991",
    "Metric Name":"Supplier Individuals: Smallholder",
    "Definition":"Number of smallholder farmer individuals who sold to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5350",
    "Metric Name":"Supplier Individuals: Total",
    "Definition":"Number of individuals who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6179",
    "Metric Name":"Supplier Individuals: Urban",
    "Definition":"Number of individuals residing in urban areas who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8337",
    "Metric Name":"Supplier Individuals: Very Poor",
    "Definition":"Number of very poor individuals who sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD4565",
    "Metric Name":"Supplier Locations",
    "Definition":"Countries where the organization's suppliers are located. Select from the options in the Reference List tab.",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6385",
    "Metric Name":"Supplier Organizations: Local",
    "Definition":"Number of local enterprises that sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9495",
    "Metric Name":"Supplier Organizations: SME",
    "Definition":"Number of small and medium-sized enterprises (SMEs) that sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9566",
    "Metric Name":"Supplier Organizations: Total",
    "Definition":"Number of enterprises that sold goods or services to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4739",
    "Metric Name":"Supplier Screening Policy",
    "Definition":"Indicates whether the organization has a written policy of evaluating supplier organizations based on their social and environmental performance and a system to monitor compliance with this policy.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3016",
    "Metric Name":"Supplier Screening Ratio",
    "Definition":"Percentage of supplier organizations during the reporting period that were screened using social and\/or environmental criteria.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD2854",
    "Metric Name":"Target Area Ecoregion",
    "Definition":"Describes the ecoregions the organization seeks to benefit as of the end of the reporting period. \n\nChoose all that apply: \n\nTerrestrial Ecoregions\n- Deserts and xeric shrublands\n- Tropical and subtropical moist broadleaf forests\n- Tropical and subtropical dry broadleaf forests\n- Tropical and subtropical coniferous forests\n- Temperate broadleaf and mixed forests\n- Temperate coniferous forest\n- Boreal forests\/Taiga\n- Tropical and subtropical grasslands, savannas and shrublands\n- Temperate grasslands, savannas and shrublands\n- Flooded grasslands and savannas\n- Montane grasslands and shrublands\n- Tundra\n- Mediterranean forests, woodlands, and scrubs\n- Mangroves\n- Other terrestrial ecoregion (describe)\n\nFreshwater Ecoregions \n- Large river ecosystems\n- Large river headwater ecosystems\n- Large river delta ecosystems\n- Small river ecosystems\n- Large lake ecosystems\n- Small lake ecosystems\n- Xeric basin ecosystems\n- Other freshwater ecoregion (describe)\n\nMarine Ecoregions\n- Polar ecoregions\n- Temperate shelf and seas ecoregions\n- Temperate upwellings\n- Tropical upwellings\n- Tropical coral\n- Other marine ecoregion (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD1676",
    "Metric Name":"Target Area Protected Status",
    "Definition":"Describes the protected status of the land the organization seeks to benefit during the reporting period.\n\nChoose all that apply:\n\n- Strict Nature Reserve (IUCN Category 1a)\n- Wilderness Area (IUCN Category Ib)\n- National Park (IUCN Category II)\n- Natural Monument or Feature (IUCN Category III)\n- Habitat\/Species Management Area (IUCN Category IV)\n- Protected Landscape\/Seascape (IUCN Category V)\n- Protected Area with Sustainable Use of Natural Resources (Category VI)\n- No Current Protections\n- Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD5752",
    "Metric Name":"Target Stakeholder Demographic",
    "Definition":"Describes the demographic groups of stakeholders targeted by the organization. Select all that apply:\n\nAge group:\n- Children (younger than 10 years old)\n- Adolescents (10 years of age or older but younger than 19)\n- Adults (19+ years old)\n- Elderly\/older adults\n\nGender:\n- Female\n- Male\n- Gender Non-Binary\n- Undisclosed\n- Other (describe)\n\nDisability Status:\n- Persons with disabilities\n- Persons without disabilities\n- Undisclosed\n\nRace\/Ethnicity\/Minority Status:\n- Historically marginalized groups\n- Dominant culture populations\n- Undisclosed\n\nOther target populations:\n- Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8145",
    "Metric Name":"Target Stakeholder Fatalities",
    "Definition":"Number of fatalities of the organization's target stakeholders during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD6424",
    "Metric Name":"Target Stakeholder Geography",
    "Definition":"Describes the geography of stakeholders targeted by the organization, expressed by country, as of the end of the reporting period. \n\nChoose all that apply: \n\n- Afghanistan\n- Albania\n- Algeria\n- Andorra\n- Angola\n- Anguilla\n- Antigua & Barbuda\n- Argentina\n- Armenia\n- Australia\n- Austria\n- Azerbaijan\n- Bahamas\n- Bahrain\n- Bangladesh\n- Barbados\n- Belarus\n- Belgium\n- Belize\n- Benin\n- Bermuda\n- Bhutan\n- Bolivia\n- Bosnia & Herzegovina\n- Botswana\n- Brazil\n- Brunei Darussalam\n- Bulgaria\n- Burkina Faso\n- Myanmar (Burma)\n- Burundi\n- Cambodia\n- Cameroon\n- Canada\n- Cape Verde\n- Cayman Islands\n- Central African Republic\n- Chad\n- Chile\n- China\n- Colombia\n- Comoros\n- Costa Rica\n- Croatia\n- Cuba\n- Cyprus\n- Czech Republic\n- Democratic Republic of the Congo\n- Denmark\n- Djibouti\n- Dominica\n- Dominican Republic\n- Ecuador\n- Egypt \n- El Salvador\n- Equatorial Guinea\n- Eritrea\n- Estonia\n- Ethiopia\n- Fiji\n- Finland\n- France\n- French Guiana\n- Gabon\n- Gambia\n- Georgia\n- Germany\n- Ghana\n- Great Britain\n- Greece\n- Grenada\n- Guadeloupe\n- Guatemala\n- Guinea\n- Guinea-Bissau\n- Guyana\n- Haiti\n- Honduras\n- Hungary\n- Iceland\n- India\n- Indonesia\n- Iran\n- Iraq\n- Israel and the Occupied Territories\n- Italy\n- Ivory Coast (C\u00f4te d'Ivoire)\n- Jamaica\n- Japan\n- Jordan\n- Kazakhstan\n- Kenya\n- Kosovo\n- Kuwait\n- Kyrgyzstan\n- Laos\n- Latvia\n- Lebanon\n- Lesotho\n- Liberia\n- Libya\n- Liechtenstein\n- Lithuania\n- Luxembourg\n- Republic of Macedonia\n- Madagascar\n- Malawi\n- Malaysia\n- Maldives\n- Mali\n- Malta\n- Martinique\n- Mauritania\n- Mauritius\n- Mayotte\n- Mexico\n- Moldova\n- Monaco\n- Mongolia\n- Montenegro\n- Montserrat\n- Morocco\n- Mozambique\n- Namibia\n- Nepal\n- Netherlands\n- New Zealand\n- Nicaragua\n- Niger\n- Nigeria\n- North Korea\n- Norway\n- Oman\n- Pacific Islands\n- Pakistan\n- Panama\n- Papua New Guinea\n- Paraguay\n- Peru\n- Philippines\n- Poland\n- Portugal\n- Puerto Rico\n- Qatar\n- R\u00e9union\n- Romania\n- Russian Federation\n- Rwanda\n- Saint Kitts and Nevis\n- Saint Lucia\n- Saint Vincent & the Grenadines\n- Samoa\n- S\u00e3o Tom\u00ea and Pr\u00edncipe\n- Saudi Arabia\n- Senegal\n- Serbia\n- Seychelles\n- Sierra Leone\n- Singapore\n- Slovakia\n- Slovenia\n- Solomon Islands\n- Somalia\n- South Africa\n- South Korea\n- South Sudan\n- Spain\n- Sri Lanka\n- Sudan\n- Suriname\n- Swaziland\n- Sweden\n- Switzerland\n- Syria\n- Tajikistan\n- Tanzania\n- Thailand\n- Timor Leste\n- Togo\n- Trinidad & Tobago\n- Tunisia\n- Turkey\n- Turkmenistan\n- Turks & Caicos Islands\n- Uganda\n- Ukraine\n- United Arab Emirates\n- United States of America\n- Uruguay\n- Uzbekistan\n- Venezuela\n- Vietnam\n- Virgin Islands (UK)\n- Virgin Islands (U.S.)\n- Yemen\n- Zambia\n- Zimbabwe",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7161",
    "Metric Name":"Target Stakeholder Injuries",
    "Definition":"Number of injuries of the organization's target stakeholders during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7163",
    "Metric Name":"Target Stakeholder Satisfaction Ratio",
    "Definition":"Score reflecting the percentage of the organization\u2019s target stakeholders who are likely to recommend the organization\u2019s product or service as of the end of the reporting period, compared with the percentage who are unlikely to recommend it.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD6384",
    "Metric Name":"Target Stakeholder Setting",
    "Definition":"Describes the setting of the groups of stakeholders targeted by the organization. Select all that apply:\n\n- Rural\n- Urban\n- Peri-urban",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD2541",
    "Metric Name":"Target Stakeholder Socioeconomics",
    "Definition":"Describes the socioeconomic groups of stakeholders targeted by the organization as of the end of the reporting period.\n\nChoose all that apply:\n\n- Lower-income\n- Lower middle-income\n- Upper middle-income\n- Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2111",
    "Metric Name":"Target Stakeholder Spending: Connectivity",
    "Definition":"Amount of money spent by an average target stakeholder on connectivity costs during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5489",
    "Metric Name":"Target Stakeholder Spending: Energy",
    "Definition":"Amount of money spent by the average target stakeholder on sources of energy during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7395",
    "Metric Name":"Target Stakeholder Spending: Health",
    "Definition":"Describes a target stakeholder's health spending as a share of their income or expenditures, or disaggregates another metric in terms of health spending as a share of income or expenditures. Select one: \n- Below 10%\n- 10\u201325%\n- Greater than 25%\n\n",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1409",
    "Metric Name":"Target Stakeholder Spending: Housing",
    "Definition":"Amount of money spent by the average target stakeholder on housing costs during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9626",
    "Metric Name":"Target Stakeholder Spending: Total",
    "Definition":"Average amount of money spent by target stakeholders during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD7212",
    "Metric Name":"Target Stakeholders",
    "Definition":"Describes which entities the organization seeks to benefit through its products, services, and operations as of the end of the reporting period. \n\nChoose all that apply: \n- Planet\n- Suppliers\n- Employees\n- Distributors\n- Clients (for example, students, patients, residents, or smallholders)\n- Microenterprises\n- Small and medium-sized enterprises (SMEs)\n- Other",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3651",
    "Metric Name":"Teacher Attendance Rate",
    "Definition":"Rate of teacher attendance during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5896",
    "Metric Name":"Teachers Employed",
    "Definition":"Number of full- and part-time teachers employed by the organization as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1902",
    "Metric Name":"Teachers Qualified",
    "Definition":"Number of teachers at the organizations as of the end of the reporting period who have obtained training or have qualifications that meet or exceed the minimum requirements of the local area.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7871",
    "Metric Name":"Teaching Experience",
    "Definition":"Average number of years of formal education for teachers and instructors as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD2348",
    "Metric Name":"Technology Type",
    "Definition":"Describes the type(s) of technologies provisioned, enabled, or adopted by an organization or their clients or communities served, during a reporting period. \n\nChoose all that apply: \n- Information and Communication Technology\n   - Internet of Things (IoT)\n   - Artificial Intelligence (AI)\n   - Big Data Analytics\n   - Blockchain\n- Renewable Energy Technology:\n   - Solar Power\n   - Wind Power\n   - Hydropower\n- Climate Technology:\n   - Precision Agriculture\n   - Early warning systems\n   - Remote Sensing\n   - Biodiversity Monitoring\n   - Waste Management\n   - Water Treatment\n   - Recycling\n   - Adaptation and resilience\n- Transportation Technology:\n   - Electric Vehicles (EVs)\n   - Autonomous Vehicles\n- Healthcare Technology:\n   - Telemedicine\n   - Medical Imaging\n   - Biotechnology\n- Construction and Infrastructure Technology:\n   - 3D Printing\n   - Smart Buildings\n- Financial Technology (Fintech):\n   - Mobile Payments\n   - Peer-to-Peer Lending\n- Educational Technology (EdTech):\n   - Learning Management Systems (LMS)\n   - Virtual Reality (VR) and Augmented Reality (AR)\n   - Carbon Capture and Storage (CCS) Technologies:\n   - Direct Air Capture\n   - Carbon Sequestration\n- Other (Describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4202",
    "Metric Name":"Temporary Employee Wages",
    "Definition":"Value of wages (including bonuses and excluding benefits) paid to all temporary employees of the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9028",
    "Metric Name":"Temporary Employees",
    "Definition":"Number of temporary employees paid by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8408",
    "Metric Name":"Temporary Employees Hours Worked",
    "Definition":"Number of paid hours worked by temporary employees of the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6978",
    "Metric Name":"Temporary Employees: Female",
    "Definition":"Number of female temporary employees paid by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD6350",
    "Metric Name":"Theory of Change",
    "Definition":"Describes the theory of change of the organization.",
    "Reporting Format":"Text",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1618",
    "Metric Name":"Threatened Species Policy",
    "Definition":"Indicates whether the organization implements policies to protect threatened species that reside in habitats affected by the organization's operations.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP5293",
    "Metric Name":"Total Assets",
    "Definition":"Value, as of the end of the reporting period, of all of the organization's assets.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP9083",
    "Metric Name":"Total Deposits",
    "Definition":"Value of the organization\u2019s customer deposits, whether voluntary, compulsory, demand, or term, as well as all other liabilities from customers as of the end of the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP2321",
    "Metric Name":"Total Expenses",
    "Definition":"Value of all expenditures incurred by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP1996",
    "Metric Name":"Total Liabilities",
    "Definition":"Value of the organization\u2019s liabilities as of the end of the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5657",
    "Metric Name":"Total Personal Connectivity Devices",
    "Definition":"Average number of connectivity devices utilized in each client household during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP6510",
    "Metric Name":"Total Revenue",
    "Definition":"Value of all revenue received by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5942",
    "Metric Name":"Toxic Materials",
    "Definition":"Amount of toxic materials used in the organization's manufacturing processes during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4194",
    "Metric Name":"Traceability System",
    "Definition":"Indicates whether the organization implements a traceability system for its raw materials.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI5044",
    "Metric Name":"Training Type",
    "Definition":"Describes the types of trainings completed by individuals as a result of the organization's activities during the reporting period.\n\nChoose all that apply:\n - Enterprise or business development training\n - Vocational or technical training\n - Anti-harassment training\n - Racial equity training\n - General social and environmental performance training\n - Undisclosed",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD9109",
    "Metric Name":"Type of Financial Institution",
    "Definition":"Describes what type of financial institution the organization is, if applicable. Select all that apply:\n\n- Community Action Agency (CAA)\n- Community Development Financial Institution (CDFI)\n- Credit Union\/Cooperative\n- Loan Fund, including microenterprise fund or Multibank Community Development Corporation (CDC)\n- Non-Banking Financial Institution\/Non-Banking Financial Corporation (NBFI\/NBFC)\n- Non-Profit\/Non-Governmental Organization, including Community Development Corporation (CDCs)\n- Rural Bank\n- Thrift, Bank, Bank Holding Company\n- Venture Capital Fund\n- Other",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD3922",
    "Metric Name":"Type of Land Area",
    "Definition":"Describes the type(s) of land present on hectares directly or indirectly controlled by the organization. Report for hectares controlled at any point during the reporting period. \nChoose all that apply: \n- Urban\/built-up land\n- Agricultural land \n- Rangeland \n- Forest land \n- Water areas \n- Wetland \n- Barren land \n- Tundra \n- Perennial snow or ice",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD1602",
    "Metric Name":"Unit of Measure",
    "Definition":"Describes the unit of measure for reporting products or services sold, produced, exported, or installed by the organization. \n\nSelect one:\n- British thermal units (Btu)\n- Gigawatt hours (GWh)\n- Hectares\n- Hours\n- Joules\n- Kilograms\n- Kilometers (Km)\n- Kilowatt-hours (kWh)\n- Licenses\n- Liters\n- Pounds\n- Quintiles\n- Square feet\n- Square meters\n- Tons\n- Other\n\nNote: Several metrics are reported in conjunction with this metric, such as Units\/Volume Sold: Total (PI1263).",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1290",
    "Metric Name":"Units\/Volume Produced",
    "Definition":"Amount of the product\/service produced by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2422",
    "Metric Name":"Units\/Volume Purchased at Price Premium",
    "Definition":"Units\/volume from individuals and organizations that sold to the organization and that have received a price premium during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3825",
    "Metric Name":"Units\/Volume Purchased from Supplier Individuals: Certified",
    "Definition":"Certified units\/volume purchased from individuals who sold to the reporting organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9428",
    "Metric Name":"Units\/Volume Purchased from Supplier Individuals: Female",
    "Definition":"Units\/volume purchased from female individuals who sold to the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6646",
    "Metric Name":"Units\/Volume Purchased from Supplier Individuals: Historically Marginalized",
    "Definition":"Units\/volume purchased from individuals belonging to groups historically marginalized on the basis of race and\/or ethnicity who sold to the reporting organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4982",
    "Metric Name":"Units\/Volume Purchased from Supplier Individuals: Smallholder",
    "Definition":"Units\/volume purchased from smallholder farmers who sold to the reporting organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7923",
    "Metric Name":"Units\/Volume Purchased from Supplier Individuals: Total",
    "Definition":"Units\/volume from individuals who sold to the reporting organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI6652",
    "Metric Name":"Units\/Volume Purchased from Supplier Organizations: Certified",
    "Definition":"Organizations should footnote details on the certification and all other assumptions used, including source of data. See usage guidance for further information.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8418",
    "Metric Name":"Units\/Volume Purchased from Supplier Organizations: Local",
    "Definition":"Units\/volume from local organizations that sold to the reporting organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5473",
    "Metric Name":"Units\/Volume Purchased from Supplier Organizations: SME",
    "Definition":"Units\/volume from small- to medium-sized enterprises (SMEs) that sold to the reporting organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2019",
    "Metric Name":"Units\/Volume Purchased from Supplier Organizations: Total",
    "Definition":"Units\/volume from organizations that sold to the reporting organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4564",
    "Metric Name":"Units\/Volume Replaced",
    "Definition":"Number of status-quo products that were replaced by products sold during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7289",
    "Metric Name":"Units\/Volume Sold: Certified",
    "Definition":"Amount of the product\/service sold by the organization as certified during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9029",
    "Metric Name":"Units\/Volume Sold: Exported",
    "Definition":"Amount of the product\/service exported by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8329",
    "Metric Name":"Units\/Volume Sold: Free",
    "Definition":"Amount of the product\/service provided by the organization for free during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1509",
    "Metric Name":"Units\/Volume Sold: Lost\/Leaked",
    "Definition":"Amount of the product\/service provided by the organization for free as a result of loss or leakage during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8454",
    "Metric Name":"Units\/Volume Sold: No Direct Payment",
    "Definition":"Amount of the product\/service sold during the reporting period for which no direct payment was provided to the organization at the time of service but for which the organization expects to be reimbursed.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI1263",
    "Metric Name":"Units\/Volume Sold: Total",
    "Definition":"Amount of the product\/service sold by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"II0324",
    "Metric Name":"Value of Capacity Building and Advisory Services Provided",
    "Definition":"Value of the investing organization's support for capacity-building efforts at investee companies as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2436",
    "Metric Name":"Value of Carbon Credits Purchased",
    "Definition":"Value of carbon credits purchased by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5983",
    "Metric Name":"Value of Commercial or Retail Infrastructure Financed",
    "Definition":"Value of commercial or retail infrastructure projected to be built or renovated as a result of investments made by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1619",
    "Metric Name":"Value of Community Development Contributions",
    "Definition":"Value of payments made by the organization during the reporting period towards activities that benefit local communities.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2410",
    "Metric Name":"Value of Community Facilities Financed",
    "Definition":"Value of community facilities projected to be built, renovated, or purchased as a result of investments made by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7788",
    "Metric Name":"Value of Community Infrastructure ",
    "Definition":"Describes the value of natural or built infrastructure accessed, managed or owned by the community for collective wellbeing, that are built new, repaired or upgraded by the organization. ",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4142",
    "Metric Name":"Value of Equity Investments Closed",
    "Definition":"Value of equity investments closed by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7940",
    "Metric Name":"Value of Equity Investments Outstanding",
    "Definition":"Value of equity investments on the organization's balance sheet at the end of the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7639",
    "Metric Name":"Value of Fines and Settlements",
    "Definition":"Value of payments made by the organization as legal or regulatory fines and settlements during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7233",
    "Metric Name":"Value of Housing Units Financed",
    "Definition":"Value of housing projected to be constructed or preserved as a result of investments made by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"II6610",
    "Metric Name":"Value of Investments in Communities Historically Marginalized Due to Race and\/or Ethnicity",
    "Definition":"Value of the investing organization's assets under management deployed to communities that are predominantly populated by groups historically marginalized due to race and\/or ethnicity as of the end of the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"II8480",
    "Metric Name":"Value of Investments in Company: Outstanding",
    "Definition":"Value of the investing organization's outstanding investment in a company as of the end of the reporting period. See usage guidance for details.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"II9005",
    "Metric Name":"Value of Investments in Company: Total",
    "Definition":"Value of the investing organization's investment in a company as of the beginning of the investment. ",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5476",
    "Metric Name":"Value of Loans Disbursed",
    "Definition":"Value of loans disbursed by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP9954",
    "Metric Name":"Value of Loans Fully Repaid on Time",
    "Definition":"Value of the organization\u2019s loans due for complete payback during the reporting period (but disbursed at any time) that were repaid no later than their due dates.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI7569",
    "Metric Name":"Value of Loans Outstanding",
    "Definition":"Value of disbursed loans remaining on the organization's balance sheet at the end of the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI4554",
    "Metric Name":"Value of New Education Facility Materials",
    "Definition":"Value of new educational facility materials provided to students by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5736",
    "Metric Name":"Value of New Education Instructional Materials",
    "Definition":"Value of new educational instructional materials provided to students by the organization during the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI3240",
    "Metric Name":"Value of Voluntary Savings Accounts",
    "Definition":"Value of voluntary savings accounts managed by the organization, including demand deposits and time deposits, as of the end of the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2112",
    "Metric Name":"Vehicle Distance Traveled",
    "Definition":"Distance traveled by vehicles owned, operated, or sold by the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1010",
    "Metric Name":"Vehicle\/Container Inactive Hours",
    "Definition":"Average number of hours spent inactive or waiting (inclusive of turnaround and dwell time) by a vehicle or container during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8836",
    "Metric Name":"Vocational\/Technical Training",
    "Definition":"Number of students receiving vocational or technical training during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1166",
    "Metric Name":"Volunteer Hours",
    "Definition":"Number of hours worked by non-employee volunteers who supported the organization during the reporting period.",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1582",
    "Metric Name":"Wage Equity",
    "Definition":"Ratio of the wages paid during the reporting period to the highest-compensated full-time employee (including bonus and excluding benefits) compared to the lowest-paid full-time employee.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9767",
    "Metric Name":"Wage Premium",
    "Definition":"Ratio of the additional average wage paid to employees of the organization compared to the average wage paid for a similar job in a similar industry or category and organization in the local market as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD3668",
    "Metric Name":"WASH Facilities Type",
    "Definition":"Describes the type of water, sanitation, and hygiene (WASH) facilities available on-site as a result of the organization's activities during the reporting period.\n\nChoose all that apply: \n- Drinking water facilities\n- Handwashing facilities\n- Menstrual hygiene waste disposal\n- Sanitation facilities\n- Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9847",
    "Metric Name":"Waste Disposed: Composted",
    "Definition":"Amount of waste disposed by the organization through composting during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8357",
    "Metric Name":"Waste Disposed: Incinerated",
    "Definition":"Amount of waste disposed by the organization through incineration during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4483",
    "Metric Name":"Waste Disposed: Landfill",
    "Definition":"Amount of waste disposed by the organization in landfills during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8843",
    "Metric Name":"Waste Disposed: Other",
    "Definition":"Amount of waste disposed by the organization through other means during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI2535",
    "Metric Name":"Waste Disposed: Recycled\/Reused",
    "Definition":"Amount of waste disposed by the organization through reuse and recycling during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6192",
    "Metric Name":"Waste Disposed: Total",
    "Definition":"Amount of waste disposed by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1346",
    "Metric Name":"Waste Produced: Hazardous Waste",
    "Definition":"Amount of hazardous waste created by the organization's operations during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7442",
    "Metric Name":"Waste Produced: Non-Hazardous Waste",
    "Definition":"Amount of non-hazardous waste created by the organization's operations during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6709",
    "Metric Name":"Waste Produced: Total",
    "Definition":"Amount of waste created by the organization's operations during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7920",
    "Metric Name":"Waste Reduced",
    "Definition":"Amount of waste reduced by the organization during the reporting period through programs for substitution, recycling, or recovery.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5926",
    "Metric Name":"Waste Reductions from Products Sold",
    "Definition":"Amount of waste reduced over the lifetime of products sold by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI5678",
    "Metric Name":"Waste Reductions from Services Sold",
    "Definition":"Amount of waste reduced during the reporting period as a result of the organization's services.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1054",
    "Metric Name":"Wastewater Removed",
    "Definition":"Volume of wastewater safely removed from client premises by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9412",
    "Metric Name":"Wastewater Treated",
    "Definition":"Volume of wastewater treated by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7860",
    "Metric Name":"Wastewater Treatment Compliance",
    "Definition":"Indicates whether the organization's practices related to the discharge of wastewater comply with local legal requirements.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9326",
    "Metric Name":"Water Conservation Strategy",
    "Definition":"Indicates whether the organization implements a conservation strategy to reduce its water usage.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4015",
    "Metric Name":"Water Conserved",
    "Definition":"Volume of water usage reduced as a result of the organization's water conservation efforts during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4467",
    "Metric Name":"Water Consumed: Groundwater",
    "Definition":"Volume of groundwater used for the organization's operations during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3031",
    "Metric Name":"Water Consumed: Municipal",
    "Definition":"Volume of water drawn from municipal water sources used for the organization's operations during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI6721",
    "Metric Name":"Water Consumed: Rainwater",
    "Definition":"Volume of rainwater used for the organization's operations during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1927",
    "Metric Name":"Water Consumed: Recycled",
    "Definition":"Volume of recycled water used for the organization's operations during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI3637",
    "Metric Name":"Water Consumed: Regions with High Water Stress",
    "Definition":"Volume of water used from regions with high or extremely high baseline water stress during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8060",
    "Metric Name":"Water Consumed: Surface Water",
    "Definition":"Volume of surface water used for the organization's operations during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI1697",
    "Metric Name":"Water Consumed: Total",
    "Definition":"Volume of water used for the organization's operations during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8828",
    "Metric Name":"Water Consumed: Wastewater",
    "Definition":"Volume of wastewater used for the organization's operations during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD3931",
    "Metric Name":"Water Consumption of Product",
    "Definition":"Volume of water used (consumed) over the lifetime of a product or system operated according to planned capacity.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD7621",
    "Metric Name":"Water Consumption of Product Replaced",
    "Definition":"Average volume of water that would have been consumed by the replaced product during the lifetime of the organization's product.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI0386",
    "Metric Name":"Water Discharged",
    "Definition":"Volume of effluents, used water, and unused water released, during the reporting period, to surface water, groundwater, seawater, or a third party and for which the organization has no further use.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI8043",
    "Metric Name":"Water Provided for Sale: Potable",
    "Definition":"Volume of potable water provided and delivered to offtaker(s) during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI9468",
    "Metric Name":"Water Provided for Sale: Total",
    "Definition":"Volume of water provided and delivered to offtaker(s) during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD6929",
    "Metric Name":"Water Provision Capacity of Product: Potable",
    "Definition":"Volume of potable water provided over the lifetime of a product or system operated according to planned capacity.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD6052",
    "Metric Name":"Water Provision Capacity of Product: Total",
    "Definition":"Volume of water provided over the lifetime of a product or system operated according to planned capacity.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD1403",
    "Metric Name":"Water Provision Capacity of Products Sold: Potable",
    "Definition":"Volume of potential potable water provided over the lifetimes of all products sold during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD2020",
    "Metric Name":"Water Provision Capacity of Products Sold: Total",
    "Definition":"Volume of potential water provided over the lifetimes of all products sold during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI7365",
    "Metric Name":"Water Quality Practices",
    "Definition":"Indicates whether the organization employs management practices to protect water quality.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI0478",
    "Metric Name":"Water Quality Standards Pass Rate",
    "Definition":"Percent of water samples at distribution or network sampling points that meet national standards for chemical water quality, residual chlorine, and microbiological contamination during the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD5786",
    "Metric Name":"Water Savings from Products Sold",
    "Definition":"Volume of water saved over the lifetimes of all products sold during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PI2884",
    "Metric Name":"Water Savings from Services Sold",
    "Definition":"Volume of water saved during the reporting period as a result of the organization's services sold.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD5087",
    "Metric Name":"Water Treatment Capacity of Product: Potable",
    "Definition":"Volume of water treated to become potable over the lifetime of a product or system operated according to planned capacity.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD8586",
    "Metric Name":"Water Treatment Capacity of Product: Total",
    "Definition":"Volume of water treated over the lifetime of a product or system operated according to planned capacity.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD3523",
    "Metric Name":"Water Treatment Capacity of Products Sold",
    "Definition":"Volume of potential water treated over the lifetimes of all products sold during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI9278",
    "Metric Name":"Water Treatment Level",
    "Definition":"Describes the level of treatment that discharged water received during the reporting period.\n\nChoose all that apply: \n- Primary treatment\n- Secondary treatment\n- Tertiary treatment\n- No treatment",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD7536",
    "Metric Name":"Water Type",
    "Definition":"Describes the type of water withdrawn, consumed, or discharged as a result of investments made by the organization during the reporting period.\n\nChoose all that apply:\n- Rainwater\n- Recycled Water\n- Groundwater\n- Surface Water \n- Seawater\n- Third Party: Municipal\n- Third Party: Wastewater\n- Other (describe)",
    "Reporting Format":"Selection",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI0263",
    "Metric Name":"Water Withdrawn",
    "Definition":"Volume of all water drawn from surface water, groundwater, seawater, or a third party for any use by the organization during the reporting period.",
    "Reporting Format":"Unit of Measure (PD1602)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"PD3079",
    "Metric Name":"Weighted Average Tenor of Loans Outstanding",
    "Definition":"Weighted average tenor of loans outstanding on the organization\u2019s balance sheet as of the end of the reporting period, measured in months. ",
    "Reporting Format":"Unit Referenced within Metric Definition",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD4232",
    "Metric Name":"Women's Career Advancement Initiative",
    "Definition":"Indicates whether the organization has an initiative in place to advance women in their workforce.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4364",
    "Metric Name":"Worker Freedom of Association Policy",
    "Definition":"Indicates whether the organization has a written policy to monitor, evaluate, and ensure its workers' freedom of association.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI8001",
    "Metric Name":"Worker Safety Policy",
    "Definition":"Indicates whether the organization has policies in place to monitor, evaluate, and ensure worker safety.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP6856",
    "Metric Name":"Working Capital",
    "Definition":"Value of the organization's operating liquidity as of the end of the reporting period.",
    "Reporting Format":"Reporting Currency (OD5990)",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"FP4224",
    "Metric Name":"Working Capital Ratio",
    "Definition":"Ratio of the organization\u2019s current assets compared to current liabilities as of the end of the reporting period.",
    "Reporting Format":"Decimal",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OI4972",
    "Metric Name":"Working Hour Policy",
    "Definition":"Indicates whether the organization has policies in place to monitor, evaluate, and ensure appropriate working hours of employees, as well as a system to monitor compliance.",
    "Reporting Format":"Yes\/No",
    "Applicability\n(Yes, No, Partial)":null
  },
  {
    "ID":"OD3520",
    "Metric Name":"Year Founded",
    "Definition":"Year the organization was founded.",
    "Reporting Format":"Date",
    "Applicability\n(Yes, No, Partial)":null
  }
]